import React, { Suspense, lazy } from "react";
import { ErrorBoundary } from "../errorHandling/errorBoundary.jsx";
import { LoginPanel } from "../login/loginPanel.jsx";
import { LoginPanelV2 } from "../login/loginPanelV2.jsx";
import { LoginWidget } from "../login/loginWidget.jsx";
import { Banner } from "./banner.jsx";
import { Modal } from "./modal.jsx";
import { MobileFooter } from "./MobileFooter.jsx";
import { MainHeader } from "./mainHeader.jsx";
import AppActions from "../../flux/AppActions";
import { Route, Switch, Link } from "react-router-dom";
import BetslipActions from "../../flux/BetslipActions";
import { isMobile } from "react-device-detect";
import { Clock } from "./clock.jsx";
import BiometricUtils from "./biometric/biometrichelper.js";

const Sportspools = lazy(() => import(/* webpackChunkName: "Sportspools" */"../Sportspools/Sportspools.jsx"));
const PromotionsPage = lazy(() => import(/* webpackChunkName: "PromotionsPage" */"../Promotions/PromotionsPage.jsx"));
const Wagering = lazy(() => import(/* webpackChunkName: "Wagering" */"../wagering/wagering.jsx"));
const Pools2 = lazy(() => import(/* webpackChunkName: "Pools" */"../Pools/Pools2.jsx"));
const GameDay = lazy(() => import(/* webpackChunkName: "GameDay" */"../gameday/gameday.jsx"));
const TextSearch = lazy(() => import(/* webpackChunkName: "TextSearch" */"./textSearch/textSearch.tsx"));
import CasinoSelector from "../casino/casinoselector.jsx";
import { TwoFAValidationWidget } from "../login/twoFAValidationWidget.jsx";
import { SplashPage } from "../SplashPage/SplashPage.jsx";
import { CookiePolicy } from "./cookiePolicy.jsx";
import CasinoUtils from "../casino/casinohelper.js";
import { TelebetPanel } from "./telebetPanel.jsx";
import GBETHelper from "../gbetutils.js";
import { NativeDownloader } from "./nativeDownloader.jsx";
import SeoFooter from "./seoFooter.tsx";
import GBETNativeInterface from "../../libs/gbetnativeinterface.js";
import BetslipStore from "../../flux/BetslipStore.js";
import GBETClientEventHelper from "../gbetclientevents.js";
import resources_en from "../../scripts/strings.en.js";
import TextSearchDummy from "./textSearch/textSearchDummy.tsx";
import PDPSStore from "../../flux/PDPSStore.ts";

const embedded = window !== top;

class AppLayout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            isLoggedIn: GBEglobal.isLoggedIn(),
            userContext: undefined,
            showLoginWidget: false,
            hideJoinNowButton: !GBEglobal.settings.accountSite?.registration,
            modalConfig: {
                show: false,
                extraClass: " big",
                modalDialogClass: "",
                config: {},
                removeCloseButton: false,
                content: {},
                footerButtons: false
            },
            priceFormatId: 1,
            currencyCode: GBEglobal.currency,
            mode: GBEglobal.mode,
            tmxInfo: {
                tmxWebSessionId: GBEUtils.createUUID(),
                tmxSessionId: "",
                tmxPageId: ""
            },
            isBlockedFromGames: false,
            previousLoginParams: null,
            showTwoFAValidationWidget: false,
            availableModes: configurationSettings.modes,
            showCasinoSearchPopUp: false,
            searchEnabled: GBEglobal.settings?.searchConfig?.enabled,
            desktopSearchbox: window.innerWidth > 1152
        };

        this.recaptchaHandlerId;
        this.onLoginRequest = this.onLoginRequest.bind(this);
        this.logoutUser = this.logoutUser.bind(this);
        this.togglePanel = this.togglePanel.bind(this);
        this.onAccountClicked = this.onAccountClicked.bind(this);
        this.onShowModal = this.onShowModal.bind(this);
        this.onModalClose = this.onModalClose.bind(this);
        this.setBetslip = this.setBetslip.bind(this);
        this.checkJumioStaus = this.checkJumioStaus.bind(this);
        this.onLogInVerify = this.onLogInVerify.bind(this);
        this.onHideTwoFAValidationWidget = this.onHideTwoFAValidationWidget.bind(this);
        this.toggleLeftnav = this.toggleLeftnav.bind(this);
        this.loadThreatMetrix = this.loadThreatMetrix.bind(this);
        this.onSearchClicked = this.onSearchClicked.bind(this);
        this.onNavOptClick = this.onNavOptClick.bind(this);

        this.leftNavRef = React.createRef();

        const thisComponent = this;
        thisComponent.dialogQueue = [];
        GBETNativeInterface.isAndroidWebView = (/(Android)/i).test(navigator.userAgent) && (/(BETDAQ)/i).test(navigator.userAgent);
        GBEglobal.androidWebViewSupportsBiometricAuthentication = true;

        //merge whitelabel specific resources with generic resources
        window.resources_en = { ...resources_en, ...window.whitelabelresources };

        GBEglobal.resources = window.resources_en;

        const getScreen = function () {
            var screenWidth = window.innerWidth;
            var screenHeight = window.innerHeight;
            var device = "desktop";

            if (screenWidth < 1200) { //992
                device = "tablet";
            }
            if (screenWidth < 768) {
                device = "mobile";
            }

            /*
                xs (for phones - screens less than 768px wide)
                sm (for tablets - screens equal to or greater than 768px wide)
                md (for small laptops - screens equal to or greater than 992px wide)
                lg (for laptops and desktops - screens equal to or greater than 1200px wide)
            */

            return {
                width: screenWidth,
                height: screenHeight,
                orientation: screenWidth > screenHeight ? "landscape" : "portrait",
                device: device
            };
        };

        window.addEventListener("click", function (e) {
            if (!window.navigator.onLine) {
                alert("You are currently offline. Please check your connection and try again.");
                e.preventDefault;
                return false;
            }
        });
        window.addEventListener("online", function () {
            window.location.reload();
        });
        window.addEventListener("resize", function () {
            GBEglobal.screen = getScreen();
            thisComponent.setState({ desktopSearchbox: GBEglobal.screen.width > 1152 });
        });
        window.addEventListener("orientationchange", function () {
            GBEglobal.screen = getScreen();
            //GBETHelper.calculateScreenDimensions();
        });
        GBEglobal.screen = getScreen();

        window.getPunterDetails = function () {
            if (thisComponent.state.userContext === undefined) {
                return undefined;
            }

            return {
                punterId: thisComponent.state.userContext.punterId.toString(),
                username: thisComponent.state.userContext.partnerUsername,
                registrationDate: thisComponent.state.userContext.registrationDate,
                email: thisComponent.state.email,
                county: thisComponent.state.userContext.country,
                country: thisComponent.state.userContext.country,
                currency: thisComponent.state.userContext.currency
            };
        };

        GBEglobal.getEventClassifierPath = function (eventClassifier, pathprefix) {

            const tabId = configurationSettings.tab.replace("sportsbook", configurationSettings.sportsbookTabName);

            const tab = "/" + tabId + "/";

            if (!isNaN(eventClassifier)) {

                var ev = thisComponent.props.controller.getCachedEventClassifier(eventClassifier);
                if (ev === undefined) {
                    return window.eventurls && window.eventurls[eventClassifier] || (tab + (pathprefix || "eventid") + "-" + eventClassifier);
                } else {
                    eventClassifier = ev;
                }
            }

            if (eventClassifier === undefined) {
                return tab;
            }

            if (eventClassifier.eventClassifierName === undefined) {
                console.error(eventClassifier);
            }
            var path = eventClassifier.eventClassifierName.toLowerCase().replace(/[\(.|,|')*]/g, "").replace(/@/g, "-v-").replace(/[\/\\:\s&*]/g, "-").replace(/\-\-/g, "-").replace(/[^a-zA-Z0-9\-]/g, "") + "-" + eventClassifier.eventClassifierId;
            var parentEvent = eventClassifier.getParent !== undefined ? eventClassifier.getParent() : undefined;

            while (parentEvent !== undefined && parentEvent !== null) {
                var folder = parentEvent.eventClassifierName.toLowerCase().replace(/[\/\\:\s&*]/g, "-").replace(/\-\-/g, "-").replace(/[^a-zA-Z0-9\-]/g, "");

                path = folder + "/" + path;
                parentEvent = parentEvent.getParent();
            }

            return tab + path;
        };

        thisComponent.state.punterDetails = {};
        if (window.telebetDetails !== undefined) {

            thisComponent.props.controller.establishTelebetSession({
                partnerTelebetToken: window.telebetDetails.token,
                //jSONWebToken: window.telebetDetails.token,
                callbackOnSuccess: function () {

                    thisComponent.props.controller.setUserContext({
                        language: "en",
                        partnerUsername: window.telebetDetails.partnerUsername,
                        currency: window.telebetDetails.currencyCode,
                        channelInformation: GBEglobal.getChannelInformation(),
                        clientIdentifier: GBEglobal.getClientIdentifier(),
                        callbackOnSuccess: async function (userContext) {
                            GBEglobal.isLoggedIn(true);
                            GBEglobal.subscriptionManagerSettings.currentlyLoggedIn = true;

                            GBEglobal.priceFormat = userContext.priceFormat;

                            if (GBEglobal.settings.pushPDPS?.enableSubscribeBalance) {

                                PDPSStore.addBalanceDelegate(function (balances) {
                                    thisComponent.setState({ balances });
                                });

                                await PDPSStore.startSubscriptions();

                                thisComponent.state.balances = await PDPSStore.getBalance();
                            }

                            Promise.all([
                                thisComponent.props.controller.getPromise("listPunterTaggedValues", {
                                    callbackOnSuccess: function () {
                                    }
                                }),
                                thisComponent.props.controller.getPromise("getPunterPreferences", {
                                    callbackOnSuccess: function () { }
                                }),
                                thisComponent.props.controller.getPromise("listFreeBetEntitlements", {
                                    callbackOnSuccess: function () { }
                                }),
                                thisComponent.props.controller.getPromise("getPunterDetails", {
                                    callbackOnSuccess: function () { }
                                })
                            ]).then(function promiseResponse(responses) {
                                const userTaggedValues = responses[0];
                                const userPreferences = responses[1];

                                thisComponent.setState({
                                    telebetPunterDetails: responses[3]
                                });

                                userContext.country = responses[3].country;
                                userContext.partnerUsername = responses[3].partnerUsername;
                                GBEglobal.currency = userContext.currency;
                                thisComponent.state.email = responses[3].email;
                                //set default ptv's
                                thisComponent.loadDefaultPreferences(userPreferences, userTaggedValues);
                                thisComponent.onLoginStatusChange(userContext, responses[2]);
                            });

                            thisComponent.props.controller.getAccountSummary({
                                callbackOnSuccess: function callbackOnSuccess(resp) {

                                    thisComponent.setState({
                                        telebetAccountSummary: resp
                                    });

                                },
                                callbackOnException: function callbackOnException(error) {
                                    console.error(error);
                                }
                            });

                            thisComponent.setState({
                                isLoaded: true,
                                isLoggedIn: userContext !== undefined,
                                isTelebetLoggedIn: userContext !== undefined,
                                userContext: userContext,
                                currencyCode: GBEglobal.currencyCode,
                                showLoginWidget: false
                            });
                        },
                        callbackOnException: function () {
                            alert("failed to set userContext");
                        }
                    });
                },
                callbackOnException: function () {
                    alert("telebet exception");
                }
            });
        } else if (thisComponent.state.isLoggedIn && !embedded) {
            this.onLoginRequest({ refresh: true });
        } else {
            this.state.isLoaded = true;
        }

        if (!embedded) {
            window.addEventListener("focus", () => {
                // if cookie says user logged in then make sure this tab is logged in or remove the cookie
                if (thisComponent.state.userContext) {

                    if (window.sessionStorage.getItem("GBET.isLoggedIn") !== null && window.sessionStorage.getItem("GBET.isLoggedIn") !== "true") {
                        thisComponent.onLoginRequest({});
                    }
                } else {
                    if (window.sessionStorage.getItem("GBET.isLoggedIn") === "true") {
                        thisComponent.logoutUser();
                    }
                }

            });
        }

        if (GBEglobal.settings.banners !== undefined) {
            Object.entries(GBEglobal.settings.banners).map(function ([key, value]) {
                if (value.replace) {
                    GBEglobal.settings.banners[key] = value.replace(/\[whitelabel\]/g, configurationSettings.whiteLabel.toLowerCase()).replace(/\[mode\]/g, configurationSettings.mode);
                }
                return true;
            });

        }

        var idleTimeoutId;
        var countdownTimerId;
        let countDownStarted = false;
        let countDownSeconds = GBEglobal.settings.idleSession.countdownSeconds;

        function messagelogoutWithMessage() {
            thisComponent.logoutUser("As you've not used this website in the last <b>" + GBEglobal.settings.idleSession.timeoutMinutes + " minutes</b> we have logged you out. We do this to protect your account.");

        }

        var startCountDownTimer = function () {

            thisComponent.props.controller.performCustomService({
                "language": "en",
                "customServiceName": "CheckLastGameActivity",
                "nameValuePairs": [
                    {
                        "name": "timeInterval",
                        "value": GBEglobal.settings.idleSession.timeoutMinutes
                    }
                ],
                callbackOnSuccess: function (resp) {

                    const timeRemaining = resp.nameValuePairs.find((o) => o.name === "timeRemaining");

                    if (timeRemaining && timeRemaining.value > 0) {
                        window.clearTimeout(idleTimeoutId);
                        idleTimeoutId = window.setInterval(function () {
                            window.clearTimeout(idleTimeoutId);
                            startCountDownTimer();
                        }, timeRemaining.value * 60000);

                        return;

                    }

                    countdownTimerId = window.setInterval(function () {
                        countDownStarted = true;
                        thisComponent.setState({
                            modalConfig: {
                                show: true,
                                content: {
                                    title: "Idle Time",
                                    bodyObject: <div>You will be logged out in {countDownSeconds--} seconds as you have been inactive for a while. <button type="button" className="btn btn-primary stay-logged-in-button" onClick={thisComponent.onModalClose}>Stay logged in</button></div>
                                },
                                modalDialogClass: "",
                                extraClass: "",
                                onClose: function () {
                                    countDownStarted = false;
                                    countDownSeconds = GBEglobal.settings.idleSession.countdownSeconds;
                                    window.clearTimeout(countdownTimerId);
                                    thisComponent.popDialogQueue();
                                }
                            }
                        });
                        if (countDownSeconds <= 0) {
                            countDownStarted = false;
                            countDownSeconds = 0; //GBEglobal.settings.idleSession.countdownSeconds;
                            window.clearTimeout(countdownTimerId);

                            thisComponent.props.controller.performCustomService({
                                "language": "en",
                                "customServiceName": "CheckLastGameActivity",
                                "nameValuePairs": [
                                    {
                                        "name": "timeInterval",
                                        "value": GBEglobal.settings.idleSession.timeoutMinutes
                                    }
                                ],
                                callbackOnSuccess: function (resp) {

                                    const timeRemaining = resp.nameValuePairs.find((o) => o.name === "timeRemaining");

                                    if (timeRemaining && timeRemaining.value > 0) {
                                        window.clearTimeout(idleTimeoutId);
                                        idleTimeoutId = window.setInterval(function () {
                                            window.clearTimeout(idleTimeoutId);
                                            startCountDownTimer();
                                        }, timeRemaining.value * 60000);

                                        thisComponent.setState({
                                            modalConfig: {
                                                show: false,
                                                extraClass: " big",
                                                modalDialogClass: "",
                                                content: {}
                                            }
                                        });

                                        return;
                                    }
                                    messagelogoutWithMessage();
                                    //thisComponent.logoutUser("As you've not used this website in the last <b>" + GBEglobal.settings.idleSession.timeoutMinutes + " minutes</b> we have logged you out. We do this to protect your account.");

                                },
                                callbackOnException: function (resp) {
                                    messagelogoutWithMessage();

                                    console.error(resp);
                                }
                            });

                        }
                    }, 1000);

                },
                callbackOnException: function (resp) {
                    console.error(resp);
                }
            });

        };
        window.startIdleCheckTimeout = function () {
            if (countDownStarted) {
                return false;
            }
            if (idleTimeoutId !== undefined) {
                window.clearTimeout(idleTimeoutId);
            }

            if (countdownTimerId !== undefined) {
                window.clearInterval(countdownTimerId);
            }

            if (thisComponent.state.userContext) {
                idleTimeoutId = window.setInterval(function () {
                    window.clearTimeout(idleTimeoutId);
                    startCountDownTimer();
                }, GBEglobal.settings.idleSession.timeoutMinutes * 60000 - GBEglobal.settings.idleSession.countdownSeconds * 1000);
            }
        };
        window.startIdleCheckTimeout();
        // if left nav is open in mobile and user clicks somewhere else then close the left nav
        window.addEventListener("click", function () {

            //if (GBETNativeInterface.isAndroidWebView) {
            //    try {

            //        GBETNativeApp.activateBiometricAuthentication("true"); // prameter isFromLogin
            //        alert("set true");
            //    } catch (ex) {
            //        alert(ex.message);
            //    }

            //}

            window.startIdleCheckTimeout();
            //if (isMobile && e.target.closest("#leftPanel") === null && !e.target.classList.contains("btn-default") && !e.target.classList.contains("navbar-toggler-icon") && thisComponent.state.leftPanelToggled && e.target.closest(".mobile-action-icons") === null) {
            //    thisComponent.togglePanel(false);
            //}
        });

        document.addEventListener("visibilitychange", function () {
            if (!thisComponent.state.userContext) {
                return false;
            }
            if (document.visibilityState === "visible") {
                const tabInactiveAt = localStorage.getItem("inactiveTabTime");
                const minDiff = Math.floor((Math.abs(new Date(tabInactiveAt) - new Date()) / 1000) / 60);
                const minPassed = (Math.abs(new Date() - new Date(tabInactiveAt)) / 1000) / 60;
                const secDiff = Math.floor((Math.abs(new Date(tabInactiveAt) - new Date()) / 1000));
                if ((minDiff >= GBEglobal.settings.idleSession.timeoutMinutes || (secDiff > countDownSeconds && countDownStarted)) && thisComponent.state.userContext) {


                    thisComponent.props.controller.performCustomService({
                        "language": "en",
                        "customServiceName": "CheckLastGameActivity",
                        "nameValuePairs": [
                            {
                                "name": "timeInterval",
                                "value": GBEglobal.settings.idleSession.timeoutMinutes
                            }
                        ],
                        callbackOnSuccess: function (resp) {

                            const timeRemaining = resp.nameValuePairs.find((o) => o.name === "timeRemaining");

                            if (timeRemaining && timeRemaining.value > 0) {
                                thisComponent.setState({
                                    modalConfig: {
                                        show: false,
                                        extraClass: " big",
                                        modalDialogClass: "",
                                        content: {}
                                    }
                                });
                                return;
                            }

                            thisComponent.logoutUser("As you've not used this website in the last <b>" + GBEglobal.settings.idleSession.timeoutMinutes + " minutes</b> we have logged you out. We do this to protect your account.");

                        },
                        callbackOnException: function (resp) {
                            console.error(resp);
                        }
                    });

                } else if (secDiff < countDownSeconds && countDownStarted || minPassed > (GBEglobal.settings.idleSession.timeoutMinutes - (GBEglobal.settings.idleSession.countdownSeconds / 60))) {
                    const secondsPassedAfterIdleCheck = Math.round(minPassed * 60) - ((GBEglobal.settings.idleSession.timeoutMinutes * 60) - GBEglobal.settings.idleSession.countdownSeconds);
                    countDownSeconds = secDiff < countDownSeconds && countDownStarted ? countDownSeconds - secDiff : Math.round(GBEglobal.settings.idleSession.countdownSeconds - secondsPassedAfterIdleCheck);
                    startCountDownTimer();
                }
            } else {
                localStorage.setItem("inactiveTabTime", new Date());
                if (isMobile) {
                    if (idleTimeoutId !== undefined) {
                        window.clearTimeout(idleTimeoutId);
                    }

                    if (countdownTimerId !== undefined) {
                        window.clearTimeout(countdownTimerId);
                    }
                }
            }
        });

        //only used when embedded within host page
        window.resizeParent = thisComponent.resizeParent;

        //window.setLegacyFunctions(thisComponent);

        window.onerror = function (msg, url, line) {

            GBEglobal.logClientEntry({
                componentName: "layout",
                subcomponentName: "unknown",
                systemInteractionType: 1,
                logEntry: msg,
                entryCode1: url,
                entryCode2: line
            });

            //var req = new XMLHttpRequest();
            //var params = "msg=" + encodeURIComponent(msg) + '&amp;url=' + encodeURIComponent(url) + "&amp;line=" + line;
            //req.open("POST", "/scripts/logerror.php");
            //req.send(params);
        };

        function checkHash() {
            switch (window.location.hash) {
                case "#join":
                    var extraQueryString = "";// add promo
                    thisComponent.onAccountClicked("joinnow", extraQueryString);
                    break;
                case "#login":
                    window.setTimeout(function () {
                        thisComponent.setState({ showLoginWidget: true });
                    }, 1000);
                    break;
                case "#footballstatistics":
                    //alert("footballstatistics");
                    break;
                case "#deposit":
                    window.location.hash = "";
                    window.setTimeout(function () {
                        thisComponent.onAccountClicked("ftm/deposit", extraQueryString);
                    }, 1000);
                    break;

                default:
                    var parts = window.location.hash.split("=");
                    if (parts[0] === "#accountsite") {
                        window.setTimeout(function () {
                            thisComponent.onAccountClicked(parts[1], extraQueryString);
                        }, 1000);
                    }

                    break;
            }
        }
        window.addEventListener("hashchange", checkHash);

        if (window.location.hash && window.location.hash !== "#") {
            checkHash();
        } else {
            switch (configurationSettings.javascriptToExecute) {
                case "join":
                    if (GBEglobal.settings.accountSite?.registration) {
                        thisComponent.onAccountClicked("joinnow", "");
                    }

                    break;
                case "login":
                    this.state.showLoginWidget = true;
                    break;
            }

        }

        //for backward compatability
        window.interfaces = {
            "resizeBannerContainerToFitImage": function () { },
            "goToJoinNow": function (mode, promoCode) {
                window.location = configurationSettings.webRoot + mode.toLowerCase().replace("sportsbook", configurationSettings.sportsbookTabName) + "?promo=" + promoCode + "#join";
            },
            "goToVirtuals": function (mode) {
                //window.interfaces.goTo(mode + "/" + promoCode);
                window.location = configurationSettings.webRoot + mode.toLowerCase().replace("sportsbook", configurationSettings.sportsbookTabName) + "/virtuals/virtual-" + GBEglobal.settings.virtualConfig.virtuals;

            },
            "showPromo": function (mode, promo) {
                console.warn("old method used: " + mode);
                window.interfaces.goTo("/promotions/" + promo);
            },
            "goToExchange": function () {
                window.interfaces.goTo("/exchange/");
            },
            "goToSportsbook": function () {
                window.interfaces.goTo("/sportsbook/");
            },
            "goToAccountSite": function (param) {
                thisComponent.onAccountClicked(param);
            },
            "goTo": function (path) {

                var parts = path.split("/");
                var mode = parts[1];

                if (mode !== configurationSettings.mode) {
                    window.location = configurationSettings.webRoot + path.substring(1);
                } else {
                    thisComponent.props.history.push(path);
                }

            },
            "getPunterDetails": function () {

            }
        };

        // Set cookie (without escaping the 'value')
        // We can't use setCookie in the GEC base, as it escapes the value
        function setCookie(c_name, value, expiredays) {

            var exdate = new Date();
            var domain = com.globalbettingexchange.base.getTopDomain();

            if (domain.indexOf(".") > -1) {
                domain = ";domain=." + domain;
            } else {
                domain = ""; //to support non localhost
            }

            exdate.setTime(exdate.getTime() + (60000 * 60 * 24 * expiredays));

            var expiry = ((expiredays === undefined) ? "" : ";expires=" + exdate.toGMTString());
            document.cookie = c_name + "=" + value + expiry + domain + ";secure;path=/";
        }

        var tempToken;
        if (window.frameElement !== null) {
            tempToken = window.frameElement.getAttribute("data-temporarytoken") || undefined;
        }

        if (tempToken !== undefined && tempToken !== null) {
            setCookie("preAuth", tempToken, 0.001); // cookieName":"preAuth"
            setCookie("sportsbookUsername", window.frameElement.getAttribute("data-username"), 0.001);

            this.onLoginRequest({});
        }

        if (embedded) {
            window.setInterval(function () {
                thisComponent.resizeParent();
            }, 1000);
        }

    }

    resizeParent() {

        const currentHeight = Math.min(document.body.scrollHeight, document.body.offsetHeight);

        if (this.previousHeight !== currentHeight) {
            this.previousHeight = currentHeight;

            parent.postMessage({
                event_id: "GBET-Iframe-resize",
                data: {
                    height: currentHeight
                }
            }, "*");

        }

    }

    refreshFreeBetEntitlements() {
        this.props.controller.listFreeBetEntitlements({
            callbackOnSuccess: function (freeBetsEntitlements) {
                BetslipActions.updateFreeBetsEntitlements(freeBetsEntitlements);
            },
            callbackOnException: function (err) {
                console.error(err);
            }
        });
    }

    componentDidMount() {
        const thisComponent = this;

        let touchstartX = 0;
        let touchendX = 0;
        if (!this.state.isLoggedIn && this.state.tmxInfo.tmxPageId === "" && this.state.tmxInfo.tmxSessionId === "" && GBEglobal.settings.threatMetrix?.login) {
            if (GBEglobal.settings.threatMetrix.lazyload === "click") {
                window.addEventListener("click", thisComponent.loadThreatMetrix);
            } else {
                thisComponent.loadThreatMetrix();
            }

        }
        function handleGesture() {
            //swipe left
            if (touchendX < touchstartX) {
                if (document.getElementById("container").classList.contains("leftPanelToggled")) {
                    thisComponent.togglePanel(false, "swipe");
                }
            }
            //swipe right
            //if (touchendX > touchstartX) {
            //    if (document.getElementById("container").classList.contains("rightPanelToggled")) {
            //        thisComponent.props.setBetslip(false, "swipe");
            //    }
            //}
        }
        if (this.leftNavRef.current !== null) {
            this.leftNavRef.current.addEventListener("touchstart", (e) => {
                touchstartX = e.changedTouches[0].screenX;
            }, {
                passive: true
            });

            this.leftNavRef.current.addEventListener("touchend", (e) => {
                touchendX = e.changedTouches[0].screenX;
                handleGesture();
            }, {
                passive: true
            });
        }


        if (GBEglobal.settings["website.TwitterTrackers"] && GBEglobal.settings["website.TwitterTrackers"].enabled) {
            window.initTwitter(GBEglobal.settings["website.TwitterTrackers"]);
        }

        if (GBEglobal.settings.hotjar && GBEglobal.settings.hotjar.enabled) {
            window.initHotjar(GBEglobal.settings.hotjar);
        }

        if (GBEUtils.qs("payPalReturn")) {
            this.onAccountClicked(window.location.hash.split("&")[0].substring(2), "");
        }

        if (GBEUtils.qs("netellerpaysafeReturn")) {
            this.onAccountClicked(window.location.hash.split("&")[0].substring(2), "");
        }

        var acceptibleQueryParams = ["aff_id", "Promo"];

        for (var i = 0; i < acceptibleQueryParams.length; i++) {
            var paramName = acceptibleQueryParams[i];
            var qsValue = GBEUtils.qs(paramName);
            if (qsValue) {
                GBEUtils.setCookie(paramName, qsValue);
            }
        }

        parent.postMessage({
            event_id: "GBET-settings",
            data: {

            }
        }, "*");

        window.addEventListener("redirect", function (event) {
            var path = event.detail.mode === ModeTypes.Singles ? "exchange/" : "sportsbook/";
            thisComponent.onModalClose();
            const url = event.detail.url ? event.detail.url : event.detail.path;
            if (event.detail.mode !== GBEglobal.mode) {
                thisComponent.props.history.push(configurationSettings.webRoot + path + url);
                window.location.reload();
            } else {
                if (url.indexOf("#") > -1) {
                    thisComponent.props.history.push(url);
                } else {
                    thisComponent.props.history.push("/" + path + url);
                }
            }
        });

        if ((GBEglobal.settings["system.Geolocation.Enabled"] === true || GBEglobal.settings["system.Geolocation.Enabled"] === "TRUE") && configurationSettings.mode === "sportsbook") {

            import("../../Libs/GBEGeoLocation.js").then((GeoLocateHelper) => {

                //test for geolocation enabled
                GBEglobal.geoLocateHelper = new GeoLocateHelper.default.GeoLocateHelper(thisComponent.props.controller, GBEglobal.settings.geolocateRules);

                window.geolocateCallback = function (messageAndType) {

                    var canTakeUpdates = true;
                    if (canTakeUpdates) {


                        //this.props.onNotification({
                        //    message: messageAndType.message,
                        //    type: messageAndType.type
                        //});
                        var message = messageAndType.message;

                        switch (message) {
                            case "A Valid Session Token Is Required To Use This Custom Service":
                                message = "You must be logged in and have location services enabled to use this functionality.";
                                break;
                        }

                        switch (messageAndType.returnCode) {

                            case 900:
                                message = "Your location is not available - this bet could not be placed";
                                break;
                            case 902:
                                message = "Your location is not permitted - this bet could not be placed";
                                break;
                        }


                        thisComponent.setState({
                            validLocation: messageAndType.type === "valid",
                            notification: messageAndType,
                            retryLocation: messageAndType.type !== "valid",
                            modalConfig: {
                                show: messageAndType.type !== "valid" ? true : false,
                                content: {
                                    title: "GeoLocation",
                                    bodyObject: <p>{message}</p>
                                },
                                modalDialogClass: "",
                                extraClass: ""
                            }

                        });

                    }
                    if (messageAndType.currentRegionCode !== undefined) {
                        GBEglobal.currentRegionCode = messageAndType.currentRegionCode;
                    }
                };
            });

        }

        function logoutSuspendedUser(text, countryCode) {
            let supportEmail = "helpdesk@" + configurationSettings.whitelabelDomain;
            if (GBEglobal.settings.zenDesk !== undefined && GBEglobal.settings.zenDesk.supportEmail !== undefined) {
                supportEmail = GBEglobal.settings.zenDesk.supportEmail;
            }
            if (text === "GAMSTOP") {
                if (countryCode === "uk") {
                    text = "Thank you. You have now completed the self exclusion process and your [whitelabel] account has been closed. ";
                    text = text + "We advise that you self-exclude from any other betting sites where you hold an account and that you use website filtering and / or blocking software to prevent you from accessing gambling websites from your personal computer.<br /><br />";
                    text = text + "<a class='host-legallink host-gamstop' style='float:right;' target='gamstop' href='https://www.gamstop.co.uk/'>Gamstop</a>";
                    text = text + "To self-exclude from all online gambling companies in Great Britain go to  <a href='https://www.gamstop.co.uk'>www.gamstop.co.uk</a><br /><br/>";
                    text = text + "Should you require any further information please contact the helpdesk by emailing <a href='mailto:" + supportEmail + "'>" + supportEmail + "</a>";
                } else {
                    text = "Thank you. You have now completed the self exclusion process and your [whitelabel] account has been closed. ";
                    text = text + "We advise that you self-exclude from any other betting sites where you hold an account and that you use website filtering and / or blocking software to prevent you from accessing gambling websites from your personal computer.<br /><br />";
                    text = text + "Should you require any further information please contact the helpdesk by emailing <a href='mailto:" + supportEmail + "'>" + supportEmail + "</a>";
                }
            } else if (text === "TIMEOUT") {
                text = "Thank You. You have now completed a Time Out from your account with [whitelabel]. Please note that your account will automatically re-open when the period of the Time Out has expired. <br />Should you require any further information please contact the helpdesk by e-mailing <a href='mailto:" + supportEmail + "'>" + supportEmail + "</a>";

            }

            text = text.replace(/\[whitelabel\]/g, configurationSettings.whitelabelDisplayName);

            thisComponent.logoutUser(text.replace(/\[whitelabel\]/g, configurationSettings.whitelabelDisplayName).replace(/\[whitelabeldomain\]/g, configurationSettings.whitelabelDomain));

        }

        window.addEventListener("message", function (event) {
            switch (event.data) {
                case "consent":
                    thisComponent.props.controller.establishUserSession({
                        partnerId: 0,
                        initialLanguage: "en",
                        numberLogonAttemptsToReturn: 1,
                        channelInformation: GBEglobal.getChannelInformation(),
                        granularChannelType: isMobile ? gec.GranularChannelType.MobileBrowser : gec.GranularChannelType.InternetBrowser,
                        callbackOnSuccess: function callbackOnSuccess(userContext) {
                            window.startIdleCheckTimeout();

                            if (GBEUtils.getCookie("LastSuccessfulLogon") === "") {
                                // the number of .net ticks at the unix epoch
                                const epochTicks = 621355968000000000;
                                // there are 10000 .net ticks per millisecond
                                const ticksPerMillisecond = 10000;
                                // calculate the total number of .net ticks for your date
                                const currentTimeTicks = epochTicks + (new Date().getTime() * ticksPerMillisecond);
                                const LastSuccessfulLogon = currentTimeTicks + "|false";

                                var domain = com.globalbettingexchange.base.getTopDomain();

                                domain = (domain.indexOf(".") > -1) ? ";domain=." + domain : ""; //to support non localhost

                                document.cookie = "LastSuccessfulLogon=" + LastSuccessfulLogon + domain + ";secure;path=/;";

                            }
                            GBEUtils.setCookie("GBE.isLoggedIn", true, null, "None;Secure");
                            GBEglobal.isLoggedInCookie = true;

                            GBEglobal.subscriptionManagerSettings.currentlyLoggedIn = true;

                            GBEglobal.priceFormat = userContext.priceFormat;
                            Promise.all([
                                thisComponent.props.controller.getPromise("listPunterTaggedValues", {
                                    callbackOnSuccess: function () {
                                    }
                                }),
                                thisComponent.props.controller.getPromise("getPunterPreferences", {
                                    callbackOnSuccess: function () { }
                                }),
                                thisComponent.props.controller.getPromise("listFreeBetEntitlements", {
                                    callbackOnSuccess: function () { }
                                }),
                                thisComponent.props.controller.getPromise("getPunterDetails", {
                                    callbackOnSuccess: function () { }
                                })
                            ]).then(function promiseResponse(responses) {
                                const userTaggedValues = responses[0];
                                const userPreferences = responses[1];
                                userContext.country = responses[3].country;
                                userContext.partnerUsername = responses[3].partnerUsername;
                                thisComponent.state.punterDetails = responses[3];
                                thisComponent.state.email = responses[3].email;
                                GBEglobal.currency = userContext.currency;
                                //set default ptv's
                                thisComponent.loadDefaultPreferences(userPreferences, userTaggedValues);
                                thisComponent.onLoginStatusChange(userContext, responses[2]);

                                if (userContext?.tmxReviewStatus?.toLowerCase() === "reject") {
                                    thisComponent.showTmxPopup();
                                }
                            });
                        },
                        callbackOnException: function callbackOnException(resp) {
                            console.error(resp);
                            GBEUtils.setCookie("GBE.isLoggedIn", false, null, "None;Secure");
                            GBEUtils.setCookie("LastSuccessfulLogon", "");
                        }
                    });
                    break;
                case "consentDone":
                    break;
                case "closeModal":
                case "be-policy-accept":
                case "successNetverify":
                    thisComponent.onModalClose();
                    break;
                case "refresh":
                    break;
                case "timeout":
                    logoutSuspendedUser("TIMEOUT");
                    break;
                case "loginConsent":
                    break;
                case "reloadSite":
                    window.location.reload();
                    break;
                case "refreshBalance":
                    thisComponent.refreshBalances();
                    thisComponent.refreshFreeBetEntitlements();
                    break;
                case "getPunterDetails":
                    event.source.postMessage({ name: "test" }, event.origin);
                    break;
                case "selfexclude":
                    logoutSuspendedUser("GAMSTOP");
                    break;
                case "termsDeclined":
                case "be-policy-notaccept":
                    thisComponent.logoutUser();
                    break;
                case "logoutFromAccountSite":
                    thisComponent.onModalClose();
                    thisComponent.logoutUser();
                    break;
                case "extendsession": // when an iframe banner requsts that its size has changed - also fired when initially loaded
                    window.startIdleCheckTimeout();
                    break;
                case "tmxreject":
                    thisComponent.showTmxPopup();
                    break;
                case "multipleCashout":
                    thisComponent.onModalClose();
                    thisComponent.props.history.push("/sportsbook/cashout");
                    break;
                case "realityCheckDone": // when reality check done then continue to launch previous game
                    if (thisComponent.launchGameParams) {
                        const launchGameParams = thisComponent.launchGameParams;
                        thisComponent.launchGameParams = undefined;
                        //close accountsite
                        var modalConfig = {
                            show: false,
                            extraClass: " accountSite big",
                            footerButtons: false
                        };
                        thisComponent.setState({ modalConfig: modalConfig });

                        thisComponent.onPlayGame(launchGameParams[0], launchGameParams[1], launchGameParams[2]);
                    }
                    break;
                default:
                    if (event.data?.url && event.data?.name === "openPopup") {
                        GBETHelper.openPopup(event.data.url);
                    }
                    if (event.data.setBalance !== undefined) {
                        localStorage.setItem("isBalanceVisible", event.data.value);
                    } else {
                        switch (event.data?.event_id) {
                            case "registrationDone":
                                GBETClientEventHelper.fireDelegate("onRegistrationDone", { mode: configurationSettings.mode, data: event.data.detail });
                                thisComponent.visitorToCustomerNativeApp();
                                break;
                            case "depositSuccess":
                                thisComponent.getBalance(function (balance) {
                                    GBETClientEventHelper.fireDelegate("onDepositDone", { mode: configurationSettings.mode, punter: window.getPunterDetails(), detail: event.data.detail, balance: balance });
                                });
                                break;
                            case "withdrawSuccess":
                                thisComponent.getBalance(function (balance) {
                                    GBETClientEventHelper.fireDelegate("onWithdrawDone", { mode: configurationSettings.mode, punter: window.getPunterDetails(), detail: event.data.detail, balance: balance });
                                });
                                break;
                            case "GBETClientEvents":
                                GBETClientEventHelper.addEventListeners(event.data?.listeners);

                                break;
                            case "GBET-settings":
                                if (event.data.data.partnerToken !== undefined) {
                                    thisComponent.onLoginRequest({ "partnerToken": event.data.data.partnerToken });
                                }

                                break;
                            case "GBET-startsession":
                                thisComponent.onLoginRequest({
                                    "partnerToken": event.data.data.partnerToken,
                                    "sessionToken": event.data.data.session,
                                    "username": event.data.data.username
                                });
                                break;
                            case "GBET-endsession":
                                thisComponent.logoutUser(event.data.data.messageAfterLogout);
                                break;

                            case "resizebanner": // when an iframe banner requsts that its size has changed - also fired when initially loaded
                                // eslint-disable-next-line no-case-declarations
                                const iframeElement = document.getElementById(event.data.data.frameId);
                                if (iframeElement) {
                                    iframeElement.style.minHeight = event.data.data.height + "px";
                                    iframeElement.style.visibility = "visible";
                                    iframeElement.parentNode.style.display = "";
                                }

                                break;
                            case "extendsession":
                                window.startIdleCheckTimeout();
                                break;
                            case "timeout":
                                logoutSuspendedUser("TIMEOUT");
                                break;

                            case "redirect":
                                var path = event.data.detail.mode === ModeTypes.Singles ? "exchange/" : "sportsbook/";
                                if (event.data.detail.mode !== GBEglobal.mode) {
                                    window.location = configurationSettings.webRoot + path + event.data.detail.path;
                                } else {
                                    thisComponent.props.history.push("/" + path + event.data.detail.path);
                                }
                                thisComponent.onModalClose();
                                break;
                            case "account":
                                thisComponent.onAccountClicked(event.data.data.path, "mode=exchange&channel=web&originUrl=https:%2F%2Flocalhost%2FGBET.Exchange.Website%2Fexchange");
                                break;
                            case "embedded":
                                alert("embedded");
                                break;
                            case "goTo":

                                var parts = event.data.data.path.split("/");
                                var mode = parts[1];

                                if (mode !== configurationSettings.mode) {
                                    window.location = configurationSettings.webRoot + path.substring(1);
                                } else {
                                    thisComponent.props.history.push(path);
                                }

                                break;
                            case "goToEvent":

                                // eslint-disable-next-line no-redeclare
                                var parts = event.data.data.path.split("/");

                                // eslint-disable-next-line no-redeclare
                                var mode = parts[1];

                                if (mode !== configurationSettings.mode) {
                                    window.location = configurationSettings.webRoot + path.substring(1);
                                } else {
                                    thisComponent.props.history.push(path);
                                }

                                break;
                        }
                    }
            }
        });


        BiometricUtils.setNativeJavascript(thisComponent);

        //window.setTimeout(function () {

        //    //GBEMobileApp.nativeToJavaScript.showSecurityAndPasswordSettings();
        //    //GBEMobileApp.nativeToJavaScript.promptToUseBiometrics("Face ID");
        //    //GBEMobileApp.nativeToJavaScript.continueLogin();
        //    //GBEMobileApp.nativeToJavaScript.continueToSecurityAndPasswordPage("WWW");
        //    //GBEMobileApp.nativeToJavaScript.notifyBiometricAuthenticationHasBeenActivated("true");
        //    //GBEMobileApp.nativeToJavaScript.goToLogin();
        //    //GBEMobileApp.nativeToJavaScript.login("klarkin", "xxxxx");


        //    //    window.GBEMobileApp.nativeToJavascript.promptToUseBiometrics("Face ID");
        //}, 3000);

        this.observer = new ResizeObserver(() => {
            this.adjustPanelHeight(undefined);
        });
        this.observer.observe(document.body);


        if (window.clientListeners) {
            GBETClientEventHelper.addEventListeners(window.clientListeners);
            GBETClientEventHelper.fireDelegate("onModeLoaded", { mode: configurationSettings.mode });
        }

        if (this.state.searchEnabled) {
            const loginPanel = document.querySelector("#loginPanel");
            loginPanel?.classList?.add("loginPanelWithSearch");
        }

        if (GBETNativeInterface.isAndroidWebView || GBETNativeInterface.isWKWebView) {
            this.reportScreenVisitToNativeApp();

            try {
                this.props.history.listen(() => this.reportScreenVisitToNativeApp());
            } catch (ex) {
                console.error("Error Listening to History: ", ex.message);
            }
        }

        thisComponent.visitorToCustomerNativeApp();
    }

    visitorToCustomerNativeApp() {
        if (GBETNativeInterface.isAndroidWebView || GBETNativeInterface.isWKWebView) {
            const punter = window?.getPunterDetails();

            let email = punter?.email;
            email = email ? email : null;

            let punterId = punter?.punterId;
            punterId = punterId ? `10${punterId}` : null; // In Optimove all of Betdaq’s customer ids have a prefix of “10”

            try {
                GBETNativeApp.visitorToCustomer(email, punterId); // Android
                return;
            } catch (ex) {
                console.error("No Native Android Object: ", ex.message);
            }

            try {
                window.webkit.messageHandlers.javaScriptToSwift.postMessage({ // IOS
                    name: "visitorToCustomer",
                    email,
                    punterId
                });
            } catch (ex) {
                console.error("No Native IOS Object: ", ex.message);
            }
        }
    }

    reportScreenVisitToNativeApp() {
        const title = window.location.href;

        const mode = configurationSettings.mode;

        try {
            GBETNativeApp.reportScreenVisit(title, mode); // Android
            return;
        } catch (ex) {
            console.error("No Native Android Object: ", ex.message);
        }

        try {
            window.webkit.messageHandlers.javaScriptToSwift.postMessage({ // IOS
                name: "reportScreenVisit",
                title,
                mode
            });
        } catch (ex) {
            console.error("No Native IOS Object: ", ex.message);
        }
    }

    deactiveNativeAppBiometric() {
        if (GBEglobal.isBiometricLoginAttempt) {
            GBEglobal.isBiometricLoginAttempt = false;

            if (GBETNativeInterface.isWKWebView) { // IOS
                window.webkit.messageHandlers.javaScriptToSwift.postMessage({
                    name: "deactivateBiometricAuthentication"
                });
            } else if (GBETNativeInterface.isAndroidWebView) { // Android
                GBETNativeApp.deactivateBiometricAuthentication();
            }
        }
    }

    componentWillUnmount() {
        if (this.observer) {
            this.observer.unobserve(document.body);
            this.observer.disconnect();
            this.observer = null;
        }
    }

    loadDefaultPreferences(userPreferences, userTaggedValues) {
        GBEglobal.preferences.marketByVolumeAmount = userPreferences.marketByVolumeAmount ? userPreferences.marketByVolumeAmount : 10;
        GBEglobal.preferences.displayClothColors = true;
        GBEglobal.preferences.displayLayToLose = true;
        GBEglobal.preferences.displayOverRound = true;
        GBEglobal.preferences.pandL = true;
        GBEglobal.preferences.displayProformaPnL = true;
        GBEglobal.preferences.displayCashoutOnMarket = true;
        GBEglobal.preferences.displayCashoutConfirmation = true;
        GBEglobal.preferences.includeSettledSelections = false;
        GBEglobal.preferences.netOfCommissions = false;
        GBEglobal.preferences.defaultCancelKeepTake = 0;
        GBEglobal.preferences.betReviewPage = true;

        userTaggedValues.forEach(function (userTaggedValue) {
            if (userTaggedValue.name !== "GEP.Preferences.marketByVolumeAmount") {
                let name = userTaggedValue.name;
                name = name.substring(name.lastIndexOf(".") + 1);

                const value = userTaggedValue.value;
                if (["true", "false"].indexOf(value) > -1) {
                    GBEglobal.preferences[name] = (value === "true");
                } else {
                    GBEglobal.preferences[name] = value;
                }
            }

        });
        GBEglobal.preferences.backRepriceOption = userPreferences.forOrderRepriceOption;
        GBEglobal.preferences.layRepriceOption = userPreferences.againstOrderRepriceOption;
        GBEglobal.preferences.includeSettledSelections = userPreferences.includeSettledSelectionsInPAndL;
    }

    getBalance(callback) {
        const thisComponent = this;
        if (GBEglobal.settings.pushPDPS?.enableSubscribeBalance) {
            if (callback) {
                const balance = PDPSStore.getBalance();
                callback(balance);
            }
        } else {

            thisComponent.props.controller.getBalance({
                callbackOnSuccess: function callbackOnSuccess(resp) {
                    if (callback) {
                        callback(resp);
                    }
                },
                callbackOnException: function callbackOnException(resp) {
                    console.error(resp);
                }
            });
        }

    }

    onLoginRequest(loginParams) {
        var thisComponent = this;

        const trustedDeviceTokenVal = window.localStorage.getItem("GBET.TDToken") !== undefined ? window.localStorage.getItem("GBET.TDToken") : null;
        const twoFactorAuthenticationCodeVal = loginParams.twoFactorAuthenticationCode !== undefined ? loginParams.twoFactorAuthenticationCode : null;
        const newDeviceName = loginParams.deviceName;

        function handleIncorrectLogin(resp) {
            console.error(resp);

            if (GBEUtils.getCookie("GBE.isLoggedIn") === "true") { //if previously logged in with an expired token and fails login
                window.location.reload();
            }
            window.sessionStorage.removeItem("GBE.isLoggedIn");
            GBEUtils.setCookie("GBE.isLoggedIn", false);
            GBEUtils.setCookie("LastSuccessfulLogon", "", null, "None;Secure");

            if (loginParams.refresh !== true) {
                var message = "Sorry, we're not able to log you in at this time. Please try again later.";
                //let supportEmail = "helpdesk@" + configurationSettings.whitelabelDomain;
                const localDeviceTokenExists = window.localStorage.getItem("GBET.TDToken") !== undefined && window.localStorage.getItem("GBET.TDToken") !== null;

                switch (resp.returnCode) {
                    case 208: // PunterSuspended
                    case 975: // PunterSelfExcluded
                        message = <p>We&#39;re sorry, but your account is currently suspended. Please <span style={{ "cursor": "pointer", "textDecoration": "underline" }} onClick={() => thisComponent.onNavOptClick("customer-service")}>contact Customer Service.</span></p>;
                        break;
                    case 520: // PICPunterNotAuthenticatedthisComponent
                    case 612: // PunterNotAuthenticated
                        message = <p>You have entered invalid credentials, please check the information you have entered and try again.<br /> Alternatively, click here if you forgot your <span style={{ "cursor": "pointer", "textDecoration": "underline" }} onClick={thisComponent.onAccountClicked.bind(thisComponent, "forgottenUsername")}>username</span> or <span style={{ "cursor": "pointer", "textDecoration": "underline" }} onClick={thisComponent.onAccountClicked.bind(thisComponent, "forgottenPassword")}>password.</span></p>;
                        // If 612 was as a result of a isBiometricLoginAttempt, remove offending username, password from secure
                        // location on device via native call deactivateBiometricAuthentication
                        thisComponent.deactiveNativeAppBiometric();
                        break;
                    case 950: // Locked account
                        message = <p>Sorry, your account is locked. Please reset your <span style={{ "cursor": "pointer", "textDecoration": "underline" }} onClick={thisComponent.onAccountClicked.bind(thisComponent, "forgottenPassword")}>password.</span></p>;
                        break;
                    case 953: // LoginCurrentlyProhibited
                        message = "Sorry, your account is not registered for this domain.";
                        break;
                    case 954: // LoginWithEmailAddressProhibited
                        message = <p>Login With Email Address Prohibited.</p>;
                        break;
                    case 958: //reCAPTCHATokenRequired
                        message = window.resources_en.ReCAPTCHATokenRequired;
                        break;
                    case 959: //reCAPTCHATokenNotValid
                        message = window.resources_en.ReCAPTCHATokenNotValid;
                        break;
                    case 965:
                        if (localDeviceTokenExists) {
                            window.localStorage.removeItem("GBET.TDToken");
                        } else {
                            message = window.resources_en.TwoFactorAuthenticationCodeNotValid;
                        }
                        break;
                    case 970:
                        break;
                }
                if (resp.returnCode === 970 || (resp.returnCode === 965 && localDeviceTokenExists)) {
                    thisComponent.setState({
                        showLoginWidget: false,
                        previousLoginParams: loginParams,
                        showTwoFAValidationWidget: true
                    });
                } else {
                    thisComponent.setState({
                        isLoaded: true,
                        modalConfig: {
                            show: true,
                            content: {
                                title: "Login Failed",
                                bodyObject: <p>{message}</p>
                            },
                            modalDialogClass: "",
                            extraClass: " smallModal"
                        }
                    });
                }
            }
        }

        function addTrustedDeviceFn() {
            if (newDeviceName) {
                const enableTrustedDevicesPtvName = "TwoFactorAuthentication.EnableTrustedDevices";
                const trustedDeviceToken = GBEUtils.createUUID();

                thisComponent.props.controller.addPunterTaggedValue({
                    name: enableTrustedDevicesPtvName,
                    value: "true",
                    callbackOnSuccess: function () {
                        thisComponent.props.controller.addTrustedDevice({
                            deviceName: newDeviceName,
                            trustedDeviceToken: trustedDeviceToken,
                            callbackOnException: function (asyncException) {
                                switch (asyncException.returnCode) {
                                    case 967:
                                        thisComponent.setState({
                                            isLoaded: true,
                                            modalConfig: {
                                                show: true,
                                                content: {
                                                    title: window.resources_en.TwoFactorAuthenticationDeviceNameAlreadyUsedWindowTitle,
                                                    bodyObject: <p>{window.resources_en.TwoFactorAuthenticationDeviceNameAlreadyUsedWindowDescription}</p>
                                                },
                                                modalDialogClass: "",
                                                extraClass: ""
                                            }
                                        });
                                        break;
                                }
                            },
                            callbackOnSuccess: function () {
                                window.localStorage.setItem("GBET.TDToken", trustedDeviceToken);
                            }
                        });
                    }
                });
            }
        }

        const establishSessionParams = {
            requestLocationInformation: false,
            initialLanguage: "en",
            numberLogonAttemptsToReturn: 3,
            channelInformation: GBEglobal.getChannelInformation(),
            granularChannelType: isMobile ? gec.GranularChannelType.MobileBrowser : gec.GranularChannelType.InternetBrowser,
            integrationPartnerId: configurationSettings.integrationPartnerId,
            partnerToken: loginParams.partnerToken,
            arbitrarySessionInformation: loginParams.sessionToken,
            partnerUsername: loginParams.username,
            cleartextPassword: loginParams.password,
            callbackOnSuccess: function callbackOnSuccess(userContext) {

                if (userContext?.hasSubPunters || userContext?.canAddSubPunters) {

                    if (!loginParams.username) {
                        thisComponent.props.controller.endUserSession({
                            callbackOnSuccess: function callbackOnSuccess() {
                            },
                            callbackOnException: function callbackOnException() {
                            }
                        });

                        GBEUtils.setCookie("GBE.isLoggedIn", false, null, "None;Secure");
                        location.reload();

                        return;
                    }
                }

                if (configurationSettings.whitelabelAuthentication !== "*" && userContext.whiteLabel.toLowerCase() !== configurationSettings.whitelabelAuthentication.toLowerCase()) {

                    thisComponent.props.controller.endUserSession({
                        callbackOnSuccess: function callbackOnSuccess() {
                        },
                        callbackOnException: function callbackOnException() {
                        }
                    });

                    handleIncorrectLogin({ returnCode: 953 });

                    return;
                }

                if (configurationSettings.whiteLabel.toLowerCase() === "betdaq" && isMobile && localStorage.rememberUsername === "true") {
                    localStorage.inputUsername = loginParams.username;
                }

                addTrustedDeviceFn();
                window.sessionStorage.setItem("GBET.isLoggedIn", true);

                if (GBEUtils.getCookie("LastSuccessfulLogon") === "") {
                    // the number of .net ticks at the unix epoch
                    const epochTicks = 621355968000000000;
                    // there are 10000 .net ticks per millisecond
                    const ticksPerMillisecond = 10000;
                    // calculate the total number of .net ticks for your date
                    const currentTimeTicks = epochTicks + (new Date().getTime() * ticksPerMillisecond);
                    const LastSuccessfulLogon = currentTimeTicks + "|false";

                    var domain = com.globalbettingexchange.base.getTopDomain();

                    domain = (domain.indexOf(".") > -1) ? ";domain=." + domain : ""; //to support non localhost

                    document.cookie = "LastSuccessfulLogon=" + LastSuccessfulLogon + domain + ";secure;path=/;";

                }
                if (GBEUtils.getCookie("GBE.isLoggedIn") === "false" || GBEUtils.getCookie("GBE.isLoggedIn") === "") {
                    GBEUtils.setCookie("GBE.isLoggedIn", true, null, "None;Secure");
                    GBEglobal.isLoggedInCookie = true;
                }

                GBEglobal.priceFormat = userContext.priceFormat;
                GBEglobal.currency = userContext.currency;

                // If isWKWebView check if authentication details are stored in the device Keychain
                // If they are this indicates that Touch/Face ID are already activated
                // If they are not and user is enrolled for biometric authentication native iOS will call back to prompt the user to activate

                if (GBEglobal.settings.biometricAuthentication) {

                    thisComponent.setState({
                        userContext: userContext,
                        showLoginWidget: false
                    });
                    if (GBETNativeInterface.isWKWebView && GBEglobal.settings.biometricAuthentication.ios.enabled) {
                        GBEglobal.establishUserSessionEnhancedParams = loginParams;

                        window.webkit.messageHandlers.javaScriptToSwift.postMessage({
                            name: "checkForAuthenticationDetailsInKeychain",
                            username: loginParams.username,
                            password: loginParams.password
                        });
                        return;
                    } else if (GBETNativeInterface.isAndroidWebView && GBEglobal.androidWebViewSupportsBiometricAuthentication && GBEglobal.settings.biometricAuthentication.android.enabled) {
                        GBEglobal.establishUserSessionEnhancedParams = loginParams;

                        const regex = /Version ([2-9][4-9])(\.\d+)?/;
                        const isMatch = regex.test(navigator.userAgent);

                        try {
                            //BetdaqPlusApp.checkForAuthenticationDetails(loginParams.username, loginParams.password);

                            if (isMatch) GBETNativeApp.checkForAuthenticationDetails(loginParams.username, loginParams.password);
                            else window.GBEMobileApp.nativeToJavaScript.continueLogin();

                        } catch (ex) {
                            console.error("Exception: Layout -> checkForAuthenticationDetails", ex.message);
                            window.GBEMobileApp.nativeToJavaScript.continueLogin();
                        }

                        return;
                    }
                }

                thisComponent.establishUserSessionIAPISuccess(loginParams, userContext);
            },
            callbackOnException: function callbackOnException(resp) {
                handleIncorrectLogin(resp);
            }
        };

        if (trustedDeviceTokenVal) {
            establishSessionParams.trustedDeviceToken = trustedDeviceTokenVal;
        }
        if (twoFactorAuthenticationCodeVal) {
            establishSessionParams.twoFactorAuthenticationCode = twoFactorAuthenticationCodeVal;
        }

        if (loginParams.reCAPTCHAToken) {
            establishSessionParams.reCAPTCHAToken = loginParams.reCAPTCHAToken;
        }

        if (!thisComponent.state.isLoggedIn && GBEglobal.settings.iovation !== undefined && GBEglobal.settings.iovation.enabled) {
            if (window.IGLOO.getBlackbox !== undefined) {
                const iovationIo = window.IGLOO.getBlackbox();
                establishSessionParams.fingerprint = iovationIo.blackbox;
            }

        }

        if (GBEglobal.settings.threatMetrix?.login && GBEglobal.settings.threatMetrix?.loginReject) {
            establishSessionParams.tmxWebSessionId = this.state.tmxInfo.tmxWebSessionId;
            establishSessionParams.tmxSessionId = this.state.tmxInfo.tmxSessionId;
            establishSessionParams.tmxPageId = this.state.tmxInfo.tmxPageId;
        }

        thisComponent.props.controller.establishUserSession(establishSessionParams);
    }

    async establishUserSessionIAPISuccess(loginParams, userContext) {
        const thisComponent = this;

        var promises = [
            thisComponent.props.controller.getPromise("listPunterTaggedValues", {
                callbackOnSuccess: function () { }
            }),
            thisComponent.props.controller.getPromise("getPunterPreferences", {
                callbackOnSuccess: function () { }
            }),
            thisComponent.props.controller.getPromise("listFreeBetEntitlements", {
                callbackOnSuccess: function () { }
            }),
            thisComponent.props.controller.getPromise("getPunterDetails", {
                callbackOnSuccess: function () { }
            })
        ];

        if (!GBEglobal.settings.pushPDPS?.enableSubscribeBalance) {
            promises.push(thisComponent.props.controller.getPromise("getBalance", {
                callbackOnSuccess: function () { }
            }));
        } else {

            PDPSStore.addBalanceDelegate(function (balances) {
                thisComponent.setState({ balances });
            });

            await PDPSStore.startSubscriptions();

            thisComponent.state.balances = await PDPSStore.getBalance();

        }

        Promise.all(promises).then(function promiseResponse(responses) {
            userContext = userContext || thisComponent.state.userContext;

            if (userContext?.hasSubPunters || userContext?.canAddSubPunters) {

                thisComponent.props.controller.endUserSession({
                    callbackOnSuccess: function callbackOnSuccess() {

                        if (loginParams.username) {
                            const form = document.createElement("form");
                            form.method = "post";
                            form.id = "theForm";
                            form.action = `${configurationSettings.hostName}/master/login.aspx`;

                            const usernameInput = document.createElement("input");
                            usernameInput.type = "hidden";
                            usernameInput.name = "username";
                            usernameInput.value = loginParams.username;
                            form.appendChild(usernameInput);

                            const passwordInput = document.createElement("input");
                            passwordInput.type = "hidden";
                            passwordInput.name = "password";
                            passwordInput.value = loginParams.password;
                            form.appendChild(passwordInput);

                            document.body.appendChild(form);

                            document.querySelector("#theForm").submit();
                        }
                    },
                    callbackOnException: function callbackOnException() {
                    }
                });


                return;
            }

            const userTaggedValues = responses[0];
            const userPreferences = responses[1];
            GBEglobal.currency = userContext.currency;
            userContext.country = responses[3].country;
            userContext.partnerUsername = responses[3].partnerUsername;

            thisComponent.state.email = responses[3].email;
            thisComponent.state.punterDetails = responses[3];

            if (!GBEglobal.settings.pushPDPS?.enableSubscribeBalance) {
                thisComponent.state.balances = responses[4];
            }

            try {
                //set default ptv's
                thisComponent.loadDefaultPreferences(userPreferences, userTaggedValues);

                thisComponent.onLoginStatusChange(userContext, responses[2], loginParams?.password);

                if (!loginParams.refresh) {

                    if (!userContext.isIdentityEstablished && GBEglobal.settings.netverify !== undefined && GBEglobal.settings.netverify.enabled === true) {
                        thisComponent.dialogQueue.push("5. checkJumioStaus");
                    }

                    const customMarketsSegment = userTaggedValues.find((o) => o.name === "CustomMarketsSegment") || "";
                    if (customMarketsSegment !== undefined) {
                        GBEUtils.setCookie("CustomMarketsSegmentPTV", customMarketsSegment.value, 30, "None;Secure");
                    }

                    const depositReminderLastShown = userTaggedValues.find((o) => o.name === "GBE.Preferences.depositReminderLastShown") || { value: 0 };

                    if (GBEglobal.settings?.depositFundsReminder?.enabled) {
                        if (isNaN(depositReminderLastShown.value) ||
                            depositReminderLastShown.value === "") {
                            depositReminderLastShown.value = 0;
                        }

                        var lastShown = new Date(depositReminderLastShown.value);

                        var now = new Date();

                        if ((((now.getTime() - lastShown.getTime()) >
                            (GBEglobal.settings.depositFundsReminder.intervalHours *
                                60 *
                                60 *
                                1000))
                        )) {
                            if (thisComponent.state.balances.availableBalance < GBEglobal.settings.depositFundsReminder.limits[userContext.currency]) {
                                thisComponent.dialogQueue.push("8. showDepositFunds");
                            }
                        }
                    }

                    const realityCheckTimer = userTaggedValues.find((o) => o.name === "Games.RealityCheckTimer");

                    if (realityCheckTimer !== undefined) {
                        thisComponent.props.controller.performCustomService({
                            customServiceName: "GetUTCTime",
                            callbackOnSuccess: function (res) {
                                if (res.nameValuePairs && res.nameValuePairs.length) {

                                    var currentTime = new Date(res.nameValuePairs[0].value);
                                    currentTime =
                                        new Date(currentTime.getTime() + (currentTime.getTimezoneOffset() * 60000));

                                    var timerParts = realityCheckTimer.value.split("|");
                                    var seconds = +timerParts[1];
                                    var startTime = new Date(timerParts[0]);

                                    startTime.setSeconds(startTime.getSeconds() + seconds);

                                    if (startTime <= currentTime) {
                                        thisComponent.props.controller.deletePunterTaggedValue({
                                            name: "Games.RealityCheckTimer",
                                            callbackOnSuccess: function () { },
                                            callbackOnException: function () {
                                                console.error("Error calling PerformCustomService. GetUTCTime");
                                            }
                                        });
                                    }
                                }
                            },
                            callbackOnException: function () {
                                console.error("Error calling PerformCustomService. GetUTCTime");
                            }
                        });
                    }

                    if (thisComponent.pageToShowAfterLogin) {
                        thisComponent.dialogQueue.push("9. " + thisComponent.pageToShowAfterLogin);
                    }

                    if (GBEglobal.settings.threatMetrix?.login && GBEglobal.settings.threatMetrix?.loginReject && userContext.tmxReviewStatus?.toLowerCase() === "reject") {
                        thisComponent.dialogQueue.push("7. showTmxPopup");
                    }

                }

            } catch (ex) {
                alert(ex.message);
            }

        });
    }

    onLoginStatusChange(userContext, freeBetsEntitlements, passwordLogin) {
        GBEglobal.logger.logToTwitter("login", GBEglobal.settings["website.TwitterTrackers"]);

        var thisComponent = this;

        if (userContext !== undefined && userContext.partnerUsername !== undefined) {
            localStorage.setItem("username", userContext.partnerUsername);

            if (window.GBETNativeApp) {
                try {
                    window.GBETNativeApp.initNotificationsFunctionality();
                } catch (ex) {
                    //alert(ex.message);
                }

            }
        }

        const newState = {
            isLoaded: true,
            isLoggedIn: userContext !== undefined,
            userContext: userContext,
            currencyCode: GBEglobal.currencyCode,
            showLoginWidget: false,
            showTwoFAValidationWidget: false
        };
        if (GBEglobal.preferences.IsBlocked !== undefined && GBEglobal.preferences.IsBlocked !== "") {
            newState.isBlockedFromGames = true;
            if (configurationSettings.mode === "casino") {
                window.location = configurationSettings.hostName;
            }
            newState.availableModes = configurationSettings.modes.filter((value) => {
                return value !== "Casino";
            });
        }
        thisComponent.setState(newState, async () => {
            if (thisComponent.state.isLoggedIn && !embedded) {

                if (GBEglobal.preferences.ForcePasswordChange) {
                    thisComponent.dialogQueue.push("4. force-password");
                }
                const marketingPreferences = JSON.parse(GBEglobal.preferences.MarketingPreferences || "{}");

                if (GBEglobal.preferences.MarketingPreferences === undefined || (marketingPreferences.products === undefined && (marketingPreferences.email || marketingPreferences.sms || marketingPreferences.phone || marketingPreferences.post))) {
                    thisComponent.dialogQueue.push("3. marketing-preferences-sr");
                }

                if (!thisComponent.state.isTelebetLoggedIn && !thisComponent.checkIfTermsAccepted(GBEglobal.settings["system.TermsConditionsVersion"], GBEglobal.preferences)) {
                    thisComponent.dialogQueue.push("2. terms-conditions");
                }

                if (GBEglobal.preferences.exchPriceFluctuations) {
                    thisComponent.dialogQueue.push("1. exchange-price-fluctuations");
                }

                thisComponent.dialogQueue.sort().reverse();

                thisComponent.popDialogQueue();

                if (GBEglobal.settings.pushPDPS?.enableSubscribeOrders) {
                    PDPSStore.addOrdersDelegate(function (order) {
                        console.log(order);
                    });

                    const orders = await PDPSStore.listOrders();
                    console.log(orders);
                }
            }

            if (passwordLogin) {
                GBETClientEventHelper.fireDelegate("onLoginChange", { mode: configurationSettings.mode, punter: window.getPunterDetails() });
                thisComponent.visitorToCustomerNativeApp();
            }
        });

        GBEglobal.freebetEntitlements = freeBetsEntitlements;

        AppActions.updatePreferences({
            userContext: userContext,
            freeBetsEntitlements: freeBetsEntitlements
        });
    }

    //list of thngs to show to user after login
    popDialogQueue() {
        const thisComponent = this;
        if (thisComponent.dialogQueue.length === 0) {
            return;
        }
        console.log("all Dialog", thisComponent.dialogQueue);
        const nextDialog = thisComponent.dialogQueue.pop().split(". ")[1];
        console.log("show Dialog", nextDialog);
        switch (nextDialog) {
            case "checkJumioStaus":
                thisComponent.checkJumioStaus({ value: GBEglobal.preferences.JumioNetverifyStatus });
                break;
            case "showTmxPopup":
                thisComponent.showTmxPopup();
                break;
            case "showDepositFunds":

                GBETHelper.showDepositFunds({
                    type: "welcomeLimit",
                    username: thisComponent.state.userContext.partnerUsername,
                    component: thisComponent,
                    availableFunds: thisComponent.state.balances.availableBalance
                });

                break;
            default:
                thisComponent.onAccountClicked(nextDialog);
                break;

        }

    }

    checkIfTermsAccepted(systemTerms, userTaggedValues) {
        const userContext = this.state.userContext;
        if (userContext?.isASubPunter) return true;

        if (systemTerms) {
            var latestTerms;
            var nowString = new Date().toISOString();

            systemTerms.forEach(function (term) {
                if (term.effective < nowString && (latestTerms === undefined || latestTerms.version < term.version)) {
                    latestTerms = term;
                }
            });

            var termsVersionTaggedValue = userTaggedValues.AcceptedTerms;
            try {
                termsVersionTaggedValue = (termsVersionTaggedValue !== undefined) ? JSON.parse(termsVersionTaggedValue) : { "version": 0 };
            } catch (ex) {
                console.error(ex.message);
                termsVersionTaggedValue = { "version": 0 };
            }

            if (latestTerms !== undefined && latestTerms.version > termsVersionTaggedValue.version) {
                return false;
            }
            return true;

        }

        return true;
    }

    checkJumioStaus(status) {

        const thisComponent = this;

        if (status && (status.value === "DocsSubmitted" || status.value === "BetdaqVerified" || status.value === "PassedJumioCheck" || status.value === "Verified")) {
            return false;
        }

        const partnerUsername = window.localStorage.username;
        const content = "Hi " + partnerUsername + ", to fully activate your account we need you to upload some documents.";

        const isAuthorizeLogin = window.location.href.indexOf("login") !== -1 && window.location.href.indexOf("?") !== -1;
        this.setState({
            modalConfig: {
                show: true,
                content: {
                    title: "Welcome Back",
                    body: "<p>" + content + "</p>"
                },
                modalDialogClass: "",
                extraClass: "",
                footerButtons: {
                    Ok: {
                        Text: "Verify",
                        onClick: function () {
                            this.props.onAccountClicked("netverify/kyc");
                        }
                    },
                    Cancel: {
                        Text: "Later"
                    }
                },
                onClose: isAuthorizeLogin ? function () {
                    const redirectUrl = new URLSearchParams(window.location.search).get("redirectUrl");
                    window.location.replace(redirectUrl);
                } : function () {
                    thisComponent.popDialogQueue();
                }
            }
        });
        return true;
    }

    logoutUser(messageAfterLogout, goToHomepage = false) {

        window.localStorage.removeItem("GBET." + configurationSettings.whiteLabel + ".sb");
        window.localStorage.removeItem("GBET." + configurationSettings.whiteLabel + ".ex");
        window.localStorage.removeItem("username");
        window.localStorage.removeItem("isBalanceVisible");


        if (window.localStorage.rememberUsername && JSON.parse(localStorage.rememberUsername) === false) {
            window.localStorage.removeItem("inputUsername");
        }

        this.setState({
            tmxInfo: {
                tmxWebSessionId: "",
                tmxSessionId: "",
                tmxPageId: ""
            }
        });
        window.sessionStorage.removeItem("GBET.isLoggedIn");
        GBEUtils.setCookie("GBE.isLoggedIn", false, null, "None;Secure");

        var thisComponent = this;

        if (window.telebetDetails !== undefined) {

            fetch(configurationSettings.baseUrl + "\/api\/logout.ashx")
                .then((response) => response.json())
                .then(() => {

                });
        }

        const reload = (goToHomepage) => {
            window.setTimeout(function () {

                if (goToHomepage) {
                    window.location.replace(configurationSettings.baseUrl);
                } else {
                    window.location.reload();
                }

            }, 2000);

        };

        thisComponent.props.controller.endUserSession({
            callbackOnSuccess: function callbackOnSuccess() {
                PDPSStore.endSubscriptions();

                GBEUtils.setCookie("LastSuccessfulLogon", "", null, "None;Secure");
                GBEglobal.preferences = {
                    marketByVolumeAmount: 1
                };

                if (messageAfterLogout !== undefined) {

                    thisComponent.setState({
                        modalConfig: {
                            show: true,
                            content: {
                                title: "Logged Out",
                                body: "<p>" + messageAfterLogout + "</p>"
                            },
                            modalDialogClass: "",
                            extraClass: "",
                            onClose: function () {
                                reload(goToHomepage);
                            }
                        }
                    });

                } else {
                    thisComponent.setState({
                        isLoggedIn: false,
                        userContext: undefined
                    }, function () {
                        reload(goToHomepage);
                    });

                }

                //close any casino game windows - window called "gameWindow"
                try {
                    var popupPlayer = window.open("", "gameWindow", "status=1,width=350,height=150");
                    popupPlayer.focus();
                    popupPlayer.close();
                } catch (ex) {
                    console.error(ex.message);
                }

                if (embedded) {
                    parent.postMessage({
                        event_id: "GBET-LogoutDone",
                        data: {}
                    }, "*");
                    return;
                }

                thisComponent.onLoginStatusChange(undefined, [], false);

            },
            callbackOnException: function callbackOnException(resp) {
                console.error(resp);

            }
        });
    }

    onHideLoginWidget() {
        this.setState({
            showLoginWidget: false
        });
    }

    onAccountClicked(page, extraQueryString) {
        GBEglobal.logger.log({ hitType: "event", eventCategory: "application", eventAction: "click", eventLabel: page });
        const thisComponent = this;
        if (!thisComponent.state.isLoggedIn && page !== "joinnow" && page !== "forgottenUsername" && page !== "forgottenPassword") {
            this.onLoginWidgetShow(true);
            this.pageToShowAfterLogin = page;

            return false;
        }
        if (typeof extraQueryString === "object" || extraQueryString === undefined) {
            extraQueryString = "";
        }
        const newState = {};
        const modalConfig = this.state.modalConfig;
        const originUrl = window.location.href;
        const config = this.props.config;
        const mode = config.mode === 3 ? "sportsbook" : "exchange";

        if (page === undefined) {
            page = "current-bets";
        }

        if ((page === "ftm/deposit" || page === "joinnow") && this.state.tmxInfo !== undefined && this.state.tmxInfo.tmxWebSessionId !== undefined) {
            extraQueryString += "&tmxwsid=" + this.state.tmxInfo.tmxWebSessionId;
        }

        if (page === "joinnow") {
            modalConfig.modalDialogClass = " joinnow_modal";
            if (GBEglobal.settings.generalConfig?.registrationUrl) {
                window.location = GBEglobal.settings.generalConfig.registrationUrl;
                return;
            }
        }

        if (page === "marketing-preferences-sr" || page === "force-password" || page === "terms-conditions" || page === "exchange-price-fluctuations") {
            modalConfig.removeCloseButton = true;
        }

        if (page.toLowerCase().indexOf("paypalreturn") >= 0 || page.toLowerCase().indexOf("netellerpaysafereturn") >= 0) {
            extraQueryString += "&" + window.location.hash.split("&")[1];
        }

        if (page === "marketing-preferences-sr") {
            modalConfig.extraClass += " marketing-preferences-sr ";
            extraQueryString += "&hideMenu=true"; //sidemenu
        }

        if (configurationSettings.accountSiteUrl) {

            var acceptibleQueryParams = ["aff_id", "Promo"];

            for (var i = 0; i < acceptibleQueryParams.length; i++) {
                var paramName = acceptibleQueryParams[i];
                if (GBEUtils.getCookie(paramName) !== "") {
                    extraQueryString += "&" + paramName + "=" + GBEUtils.getCookie(paramName);
                }
            }

            if (GBEUtils.qs("gbe-whitelabel") !== null || GBEUtils.getCookie("gbe-whitelabel") !== "") {
                const urlWhitelabel = GBEUtils.qs("gbe-whitelabel") !== null ? GBEUtils.qs("gbe-whitelabel") : GBEUtils.getCookie("gbe-whitelabel");
                extraQueryString += "&gbe-whitelabel=" + urlWhitelabel;
            }
            //extraQueryString += (configurationSettings.whiteLabel.toLocaleLowerCase() === "betdaq" && configurationSettings.isAndroidWebView) ? "&channel=mobile" : "&isNewDesktopOrigin=true&channel=web";
            extraQueryString += "&isNewDesktopOrigin=true&channel=web&whiteLabel=" + configurationSettings.whiteLabel;
            /* PD-136963 */
            var accountSiteUrl = configurationSettings.accountSiteUrl + page + "?mode=" + mode + (extraQueryString || "") + "&originUrl=" + originUrl;

            modalConfig.show = true;
            modalConfig.extraClass += " accountSite big";
            modalConfig.content = {
                iframeSrc: accountSiteUrl
            };
            modalConfig.footerButtons = false;
            newState.modalConfig = modalConfig;
            this.setState(newState);

        }
    }

    toggleSearch(value) {
        const textSearch = document.querySelector(".textSearch-container");

        if (value && textSearch) {
            textSearch.style.visibility = "unset";
            return;
        }

        if (textSearch) {
            textSearch.style.visibility = "hidden";
        }
    }

    togglePanel(isRightPanel, value) {
        GBEglobal.logger.log({ hitType: "event", eventCategory: "toggle-mobile-column", eventAction: "click", eventLabel: value });
        document.body.classList.remove("overflow-hidden");
        document.getElementById("container").classList.remove("stakepad-visible");

        if (isRightPanel === "left-nav") {
            this.toggleLeftnav(value);
            return;
        }

        if (isRightPanel) {
            if (document.getElementById("container").classList.contains("rightPanelToggled")) {
                document.getElementById("container").classList.remove("rightPanelToggled");
                this.toggleSearch(true);
            } else {
                document.getElementById("container").classList.add("rightPanelToggled");
                this.toggleSearch(false);
            }

            document.getElementById("container").classList.remove("leftPanelToggled");
        } else {

            this.toggleLeftnav();
        }

        if (isRightPanel && document.getElementById("container").classList.contains("rightPanelToggled")) {
            if (isMobile || GBEglobal.screen.width <= 1152) {
                document.body.classList.add("overflow-hidden");
                document.getElementById("container").classList.remove("stakepad-visible");
                //BetslipActions.toggleBetslip();
                setTimeout(function () {
                    if (document.activeElement.className.indexOf("stake") !== -1 || document.activeElement.className.indexOf("odds") !== -1) {
                        document.activeElement.scrollIntoView();
                    }
                }, 200);
            }

            // PD-152060
            const { collapsed } = BetslipStore.getBetslipState();
            if (collapsed) {
                BetslipActions.expandBetslip();
            }
        }
    }

    setBetslip(show) {
        if (show) {
            document.getElementById("container").classList.add("rightPanelToggled");
        } else {
            document.getElementById("container").classList.remove("rightPanelToggled");
            document.getElementById("container").classList.remove("stakepad-visible");
        }
    }

    toggleLeftnav(show) {
        const willShow = show === undefined ? !this.state.leftPanelToggled : show;


        this.adjustPanelHeight(undefined, true);

        this.setState({
            leftPanelToggled: willShow,
            rightPanelToggled: false
        });

    }

    adjustPanelHeight(show, toggle) {
        if (this.state.mode === -1) { // -1 = Casino Mode
            document?.querySelector(".leftPanel")?.removeAttribute("style");
            document?.querySelector(".new-casino-header > .col-12[style]")?.removeAttribute("style");
            return;
        }

        const leftPanel = document.querySelector(".leftPanel");
        const willShow = show === undefined ? !this.state.leftPanelToggled : show;

        // https://stackoverflow.com/questions/5484578
        const documentWidth = Math.max(
            document.documentElement["clientWidth"],
            document.body["scrollWidth"],
            document.documentElement["scrollWidth"],
            document.body["offsetWidth"],
            document.documentElement["offsetWidth"]
        );

        // WillShow, has different values if invoked in toggleLeftNav method
        // Or in observer Line: "1011"
        let willShow2 = willShow;
        if (toggle) {
            willShow2 = !willShow;
        }

        // Remove height only when in mobile mode, or left nav is hidden
        if (isMobile || documentWidth <= 1152) { // 1152px width, when leftNav is hidden to the burger menu
            // Collapsed leftPanel height causes container div to create extra un-needed height
            if (willShow2 && documentWidth <= 1152) { // another check for "documentWidth <= 1152", for edge case when in mobile mode but, screen size > 1152
                setTimeout(() => {
                    leftPanel?.setAttribute("style", "height: 0 !important");
                }, 200); // When leftNav collapses and height is set to 0, the background of nav becomes white, delay this to prevent user from seeing it
            } else {
                leftPanel?.removeAttribute("style");
            }
        } else {
            leftPanel?.removeAttribute("style");
        }
    }

    onModalClose() {
        const thisComponent = this;
        document.body.classList.remove("overflow-hidden");
        if (thisComponent.state.modalConfig.show) {
            const onClose = thisComponent.state.modalConfig.onClose;
            thisComponent.setState({
                modalConfig: {
                    show: false,
                    extraClass: " big",
                    modalDialogClass: "",
                    content: {}
                }
            }, function () {
                if (onClose !== undefined) {
                    onClose();
                }
                thisComponent.popDialogQueue();

            });
        }
    }

    onShowModal(config) {
        let modalConfig = this.state.modalConfig;
        modalConfig.show = true;
        modalConfig = Object.assign(modalConfig, config);

        this.setState({
            modalConfig: modalConfig
        });
    }

    onLoginWidgetShow(value, data) {

        const embedded = (top !== window);


        if (embedded) {
            parent.postMessage({
                event_id: "GBET-LogonRequired",
                data: {
                    name: "test"

                }
            }, "*");
            return;
        }

        data = data || {};

        if (value && GBEglobal.androidWebViewSupportsBiometricAuthentication) {
            try {
                // If isWKWebView and this method has not been invoked by WKWebView, call authenticateWithBiometrics on native
                // If for whatever reason authenticateWithBiometrics is not available native will call back to login page
                if (GBETNativeInterface.isWKWebView && GBEglobal.settings.biometricAuthentication?.ios.enabled && !data.invokedFromNativeApp) {
                    // Disable Login form pending outcome of biometric authentication...
                    // GBEMobileGEP.pages.login.disableLoginForm();
                    window.webkit.messageHandlers.javaScriptToSwift.postMessage({
                        name: "authenticateWithBiometrics"
                    });
                    return;
                } else if (GBETNativeInterface.isAndroidWebView && GBEglobal.settings.biometricAuthentication?.android.enabled && !data.invokedFromNativeApp) {
                    //GBEMobileGEP.pages.login.disableLoginForm();
                    // try/catch for scenario whereby biometricAuthentication.android.enabled is true but user is using Android app pre Version 3.3.2T,
                    // therefore authenticateWithBiometrics() is not defined. If the catch is triggered we assume this to be the case and note same for
                    // future checks of GBETNativeInterface.isAndroidWebView

                    try {
                        GBETNativeApp.authenticateWithBiometrics();
                    } catch (ex) {
                        // User is using an app version which does not support biometrics
                        console.error("Exception: layout -> authenticateWithBiometrics", ex.message);
                        window.GBEMobileApp.nativeToJavaScript.goToLogin();
                    }

                    return;
                }


            } catch (ignore) {
                // GBEMobileGEP.pages.login.enableLoginForm();
                GBEglobal.androidWebViewSupportsBiometricAuthentication = false;

            }
        }
        const newState = {
            showLoginWidget: value
        };
        if (data.hideJoinNowButton !== undefined) {
            newState.hideJoinNowButton = data.hideJoinNowButton;
        }
        this.setState(newState);
    }

    getAvailableBalance() {
        if (this.loginPanel) {
            const balances = this.loginPanel.getBalances();
            if (balances) {
                return +balances.availableBalance;
            }
        }

        return undefined;
    }

    refreshBalances() {
        if (this.loginPanel) {
            this.loginPanel.refreshBalances();
        }
    }

    clickLogo(e) {
        GBEglobal.logger.log({ hitType: "event", eventCategory: "application", eventAction: "click", eventLabel: "logo" });
        //want a full page reload to stop listOrderChangeSince
        e.preventDefault();
        window.location = e.currentTarget.href;
    }

    onNavOptClick(value) {
        GBEglobal.logger.log({ hitType: "event", eventCategory: "application", eventAction: "click", eventLabel: value });

        if (value === "customer-service" && GBEglobal.settings.zenDesk !== undefined && GBEglobal.settings.zenDesk.enabled) {
            if (GBEglobal.settings.zenDesk.customerService) {
                const url = GBEglobal.settings.zenDesk.customerService;
                const params = "left=" + (screen.width - 730) + ",top=30,width=1060,height=430,resizable=yes,scrollbars=auto";
                window.open(url, "_blank", params);
            } else {
                if (window.openChat !== undefined) {
                    window.openChat();
                } else {
                    window.zE.activate();
                }
            }
        } else if (value === "help" && GBEglobal.settings.zenDesk !== undefined && GBEglobal.settings.zenDesk.helpCenter !== undefined) {
            const url = GBEglobal.settings.zenDesk.helpCenter;
            const params = "left=" + (screen.width - 730) + ",top=30,width=1060,height=430,resizable=yes,scrollbars=auto";
            window.open(url, "_blank", params);
        }

        this.setState({
            modalConfig: {
                show: false
            }
        });
    }

    onPlayGame(game, forReal, sameTab) {
        const thisComponent = this;

        if (!thisComponent.state.userContext) {
            thisComponent.onLoginWidgetShow(true);
            return;
        }

        function showRealityCheckSettings() {

            var realityCheckMinutes = "1800";
            const radioStyle = {
                "borderRadius": "5px",
                "padding": "5px",
                "margin": "10px 5px",
                "border": "solid 1px #ccc"
            };


            function setRealityCheckTime(minutes) {
                realityCheckMinutes = minutes;
            }

            function setRealityCheck() {
                thisComponent.props.controller.addPunterTaggedValue({
                    name: "Games.RealityCheckSettings",
                    value: realityCheckMinutes,
                    callbackOnException: function (response) {
                        console.error(response);
                    },
                    callbackOnSuccess: function () {
                        thisComponent.setState({
                            modalConfig: {
                                show: false
                            }
                        }, function () {

                            thisComponent.onPlayGame(game, forReal, sameTab);
                        });

                    }
                });
            }

            thisComponent.setState({
                modalConfig: {
                    show: true,
                    content: {
                        title: "Reality Check",
                        markup: <div style={{ "textAlign": "center" }}>Set a reminder for a specific timeframe within our casino product.  Reality check will launch after set time and provide the option to stop playing or to continue for another time period.  Reality check applies to products within the casino tab only.<div > <label style={radioStyle}><input type="radio" value="1800" name="rdminutes" defaultChecked onClick={setRealityCheckTime.bind(this, "1800")} /> 30 Minutes </label> <label style={radioStyle}> <input type="radio" value="3600" name="rdminutes" onClick={setRealityCheckTime.bind(this, "3600")} /> 60 Minutes </label><br /> <button style={{ "borderRadius": "5px" }} onClick={setRealityCheck.bind(this)}>Set Reality Check</button></div></div>
                    },
                    modalDialogClass: "",
                    extraClass: "",
                    onClose: function () {

                    }
                }
            });


        }

        thisComponent.props.controller.getPunterTaggedValue({
            name: "Games.RealityCheckSettings",
            callbackOnException: function (response) {
                console.error(response);
                showRealityCheckSettings();
            },
            callbackOnSuccess: function (response) {
                if (response && response.value) {
                    CasinoUtils.playGame(thisComponent, game, forReal, isMobile, sameTab);
                } else {
                    showRealityCheckSettings();
                }
            }
        });
    }

    onSearchClicked() {
        this.setState({
            showCasinoSearchPopUp: !this.state.showCasinoSearchPopUp
        });
    }


    loadThreatMetrix() {
        const tmxGTV = GBEglobal.settings.threatMetrix;

        window.removeEventListener("click", this.loadThreatMetrix);

        const tmxPageId = this.state.mode === 3 ? 100 : 90;
        const tmxMessage = "consumer-login" + Date.now();
        const tmxSessionId = GBETHelper.SHA256hash(tmxMessage, true) + GBETHelper.randomStr(10);

        window[tmxGTV.jsClassName].pfbt(tmxGTV.subdomain, tmxGTV.organisationId, tmxSessionId, tmxPageId);

        this.setState((prevState) => ({
            tmxInfo: {
                ...prevState.tmxInfo,
                tmxSessionId: tmxSessionId,
                tmxPageId: tmxPageId
            }
        }));
    }

    showTmxPopup() {
        const thisComponent = this;
        const message = GBEglobal.settings.threatMetrix.rejectedMessage;

        thisComponent.setState({
            modalConfig: {
                show: true,
                content: {
                    title: "We are sorry",
                    body: "<p>" + message + "</p>"
                },
                modalDialogClass: "",
                extraClass: "",
                onClose: function () {
                    thisComponent.popDialogQueue();
                }
            }
        });
    }

    onLogInVerify(verifyParams) {
        const previousLoginParams = this.state.previousLoginParams;
        previousLoginParams.twoFactorAuthenticationCode = verifyParams.twoFactorAuthenticationCode;
        previousLoginParams.deviceName = verifyParams.deviceName;
        this.onLoginRequest(previousLoginParams);
    }

    onHideTwoFAValidationWidget() {
        this.setState({
            showTwoFAValidationWidget: false
        });
    }

    showCookiePolicy() {
        return !configurationSettings.isWebCrawler && GBEglobal.settings.cookiePolicy !== undefined && GBEglobal.settings.cookiePolicy.enabled && GBEUtils.getCookie("knowsCookies") !== "true" && window.telebetDetails === undefined;
    }

    render() {
        const isLoggedInClass = this.state.isLoggedIn ? "loggedIn" : "";
        let isTelebetLoggedIn, telebetBackground;

        if (this.state.isTelebetLoggedIn) {
            isTelebetLoggedIn = " isTelebetLoggedIn";
            telebetBackground = GBEglobal.settings.telebetHeader ? GBEglobal.settings.telebetHeader.background : "#FFD700";
        }

        const homepageRegexSuffix = "|)"; // if no path

        const wageringRegex = this.state.availableModes[0] !== "Casino" ? "/:a(sportsbook.*|exchange.*|multiples.*|fancy.*|login.*|)" : "/:a(sportsbook.*|exchange.*|fancy.*)";

        const casinoRegex = "/:a(casino.*" + (this.state.availableModes[0] === "Casino" ? homepageRegexSuffix : ")");
        const gameDayRegex = "/:a(gameday.*|account.*" + (this.state.availableModes[0] === "Gameday" ? homepageRegexSuffix : ")");
        const poolsRegex = "/:a(pools.*" + (this.state.availableModes[0] === "Pools" ? homepageRegexSuffix : ")");

        var sportsbookIndex = this.state.availableModes.indexOf("Sportsbook");
        var exchangeIndex = this.state.availableModes.indexOf("Exchange");

        var firstWageringIndex = 1000;
        if (sportsbookIndex > -1) {
            firstWageringIndex = Math.min(firstWageringIndex, sportsbookIndex);
        }
        if (exchangeIndex > -1) {
            firstWageringIndex = Math.min(firstWageringIndex, exchangeIndex);
        }

        var notFound = location.href.indexOf("notfound") > -1 || location.href.indexOf("undefined") > -1;
        var showOldLoginArea = false;
        var logoLink = "/";

        if (GBEglobal.settings.generalConfig !== undefined) {

            if (GBEglobal.settings.generalConfig.loginArea === 2 && !isMobile) {
                showOldLoginArea = true;
            }
            if (GBEglobal.settings.generalConfig.logoStaysInVertical) {
                switch (configurationSettings.mode) {
                    case "sportsbook":
                        logoLink = "/sportsbook";
                        break;
                    case "exchange":
                        logoLink = "/exchange";
                        break;
                }
            }
        }

        const loadingStyle = { "minHeight": window.screen.height };
        const showSearch = this.state.searchEnabled && (this.state.mode === ModeTypes.Singles || this.state.mode === ModeTypes.Sportsbook);
        return (
            <div id="container" className={(this.state.leftPanelToggled ? " leftPanelToggled" : "") + (this.state.rightPanelToggled ? " rightPanelToggled" : "") + (isMobile ? " noselect" : "") + (embedded ? " embedded" : "")} >
                <div id="irecaptcha"></div>
                <div id="header" className={isTelebetLoggedIn} style={{ "background": telebetBackground }}>

                    <div className="leftNavMask" ref={this.leftNavRef} onClick={this.toggleLeftnav.bind(this, undefined)}>

                    </div>

                    {isTelebetLoggedIn &&
                        <TelebetPanel onLogoutRequest={this.logoutUser} telebetAccountSummary={this.state.telebetAccountSummary} telebetPunterDetails={this.state.telebetPunterDetails} />
                    }

                    {!embedded &&
                        <nav className="row navbar navbar-expand-lg navbar-light set-max-width">
                            <div>
                                <button title="menu" className="navbar-toggler" type="button" onClick={() => this.toggleLeftnav(undefined)}>
                                    <span className="navbar-toggler-icon"></span>
                                </button>
                            </div>
                            <div className="logo">
                                <Link to={logoLink} onClick={this.clickLogo} style={{ "display": (isMobile ? "" : "contents") }}>
                                    <img
                                        src={`${configurationSettings.baseUrl}${configurationSettings.globalVersion}themes/${configurationSettings.whiteLabel}/styles/images/logo.png`}
                                        alt=""
                                        loading="eager"
                                    />
                                </Link>
                                <div className={"siteTitle " + configurationSettings.whiteLabel}>{configurationSettings.whiteLabel}</div>
                                {showSearch && this.state.desktopSearchbox &&
                                    (
                                        <Suspense fallback={<TextSearchDummy desktopSearchbox={this.state.desktopSearchbox} />}>
                                            <div className={"textSearch-container-desktop"}>
                                                <TextSearch isLoggedIn={this.state.isLoggedIn} desktopSearchbox={this.state.desktopSearchbox} /> :
                                            </div>
                                        </Suspense>
                                    )
                                }
                            </div>
                            {window.canHaveSession === true &&
                                <div className="d-flex">
                                    <div className="navbar-tools">
                                        {showOldLoginArea &&
                                            <LoginPanelV2
                                                ref={(node) => {
                                                    this.loginPanel = node;
                                                }}
                                                controller={this.props.controller}
                                                onLoginRequest={this.onLoginRequest}
                                                onLogoutRequest={this.logoutUser}
                                                onAccountClicked={this.onAccountClicked}
                                                onLoginWidgetShow={this.onLoginWidgetShow.bind(this)}
                                                userContext={this.state.userContext} />


                                        }


                                        {!showOldLoginArea &&
                                            <button className={`btn btn-primary btn-account ${!showSearch ? isLoggedInClass : ""}`} onClick={this.onAccountClicked.bind(this, "account-summary")}><span className="material-icons">account_circle</span>
                                            </button>
                                        }
                                        {GBEglobal.settings.zenDesk !== undefined && GBEglobal.settings.zenDesk.helpCenter !== undefined &&
                                            <button className="btn btn-primary d-none d-md-inline-block help" onClick={this.onNavOptClick.bind(this, "help")}><span className="material-icons">help_outline</span></button>
                                        }
                                        {!showOldLoginArea &&
                                            <button className="btn btn-primary d-none d-md-inline-block my-preferences" onClick={this.onAccountClicked.bind(this, "my-preferences")}><span className="material-icons">settings</span></button>

                                        }
                                        {GBEglobal.settings.zenDesk !== undefined && GBEglobal.settings.zenDesk.enabled && GBEglobal.settings.zenDesk.key &&
                                            <button className="btn btn-primary d-none d-md-inline-block customer-service" onClick={this.onNavOptClick.bind(this, "customer-service")}><span className="material-icons">headset_mic</span></button>
                                        }
                                        {this.state.isLoggedIn && isMobile !== true && configurationSettings.whiteLabel.toLocaleLowerCase() !== "betdaq" &&
                                            <Clock />
                                        }

                                    </div>
                                    {showSearch && !this.state.desktopSearchbox &&
                                        (
                                            <Suspense fallback={<TextSearchDummy desktopSearchbox={this.state.desktopSearchbox} />}>
                                                <div className={"textSearch-container"}>
                                                    <TextSearch isLoggedIn={this.state.isLoggedIn} desktopSearchbox={this.state.desktopSearchbox} />
                                                </div>
                                            </Suspense>
                                        )
                                    }
                                </div>
                            }
                        </nav>
                    }
                    <div className="top-navigation row d-flex">
                        <div className="col-12 set-max-width">
                            <div className="row">
                                <MainHeader modes={this.state.availableModes} />
                                {!showOldLoginArea && configurationSettings.mode.toLowerCase() !== "gameday" &&
                                    <div className="col text-right">
                                        <LoginPanel
                                            ref={(node) => {
                                                this.loginPanel = node;
                                            }}
                                            controller={this.props.controller}
                                            onLoginRequest={this.onLoginRequest}
                                            onLogoutRequest={this.logoutUser}
                                            onAccountClicked={this.onAccountClicked}
                                            onLoginWidgetShow={this.onLoginWidgetShow.bind(this)}
                                            userContext={this.state.userContext} />
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>

                {this.state.isLoaded &&
                    <ErrorBoundary componentName="Wagering">
                        <Suspense fallback={<div style={loadingStyle}></div>}>
                            <Switch>

                                {GBEglobal.settings.splashPage?.enabled &&
                                    <Route path="*" render={(props) => <SplashPage {...props} controller={this.props.controller} config={GBEglobal.settings.splashPage} modes={this.state.availableModes} />} />
                                }

                                <Route exact path="/sportspools" render={(props) => <Sportspools {...props} controller={this.props.controller} togglePanel={this.togglePanel.bind(this)} onLoginWidgetShow={this.onLoginWidgetShow.bind(this)} onAccountClicked={this.onAccountClicked} userContext={this.state.userContext} />} />

                                {!this.state.isBlockedFromGames &&
                                    <Route path={casinoRegex} exact render={(props) => <CasinoSelector {...props} controller={this.props.controller} onPlayGame={this.onPlayGame.bind(this)} togglePanel={this.togglePanel.bind(this)} onLoginWidgetShow={this.onLoginWidgetShow.bind(this)} onAccountClicked={this.onAccountClicked} userContext={this.state.userContext} punterDetails={this.state.punterDetails} modes={this.state.availableModes} showCasinoSearchPopUp={this.state.showCasinoSearchPopUp} onSearchClicked={this.onSearchClicked} />} />
                                }

                                {!this.state.isBlockedFromGames &&
                                    <Route path="/casino/:groupId" render={(props) => <CasinoSelector {...props} controller={this.props.controller} onPlayGame={this.onPlayGame.bind(this)} togglePanel={this.togglePanel.bind(this)} onLoginWidgetShow={this.onLoginWidgetShow.bind(this)} onAccountClicked={this.onAccountClicked} userContext={this.state.userContext} punterDetails={this.state.punterDetails} modes={this.state.availableModes} showCasinoSearchPopUp={this.state.showCasinoSearchPopUp} onSearchClicked={this.onSearchClicked} />} />
                                }

                                <Route path="/promotions:promotionpage(.*)" render={({ match, props }) => <PromotionsPage {...props} history={this.props.history} pathMatch={match.params} controller={this.props.controller} togglePanel={this.togglePanel.bind(this)} onLoginWidgetShow={this.onLoginWidgetShow.bind(this)} onAccountClicked={this.onAccountClicked} userContext={this.state.userContext} modes={this.state.availableModes} />} />

                                <Route path="/pages/:dynamicpage" render={({ match, props }) => <PromotionsPage {...props} history={this.props.history} pathMatch={match.params} controller={this.props.controller} togglePanel={this.togglePanel.bind(this)} onLoginWidgetShow={this.onLoginWidgetShow.bind(this)} onAccountClicked={this.onAccountClicked} userContext={this.state.userContext} modes={this.state.availableModes} />} />
                                <Route path={poolsRegex} render={({ match, props }) => <Pools2 {...props} history={this.props.history} pathMatch={match.params} controller={this.props.controller} togglePanel={this.togglePanel.bind(this)} onLoginWidgetShow={this.onLoginWidgetShow.bind(this)} onAccountClicked={this.onAccountClicked} userContext={this.state.userContext} />} />

                                <Route path={gameDayRegex} render={({ match, props }) => <GameDay
                                    {...props}
                                    history={this.props.history}
                                    pathMatch={match.params}
                                    subscriptionManager={this.props.subscriptionManager}
                                    controller={this.props.controller}
                                    togglePanel={this.togglePanel.bind(this)}
                                    onLoginWidgetShow={this.onLoginWidgetShow.bind(this)}
                                    onAccountClicked={this.onAccountClicked}
                                    isLoggedIn={this.state.isLoggedIn}
                                    onLogoutRequest={this.logoutUser}
                                    onShowModal={this.onShowModal}
                                    onModalClose={this.onModalClose}
                                    userContext={this.state.userContext}
                                    modes={this.state.availableModes}
                                />} />

                                <Route path={wageringRegex} render={(props) => <Wagering {...props} notfound={notFound} controller={this.props.controller}
                                    mode={this.state.mode}
                                    history={this.props.history}
                                    setBetslip={this.setBetslip}
                                    isLoggedIn={this.state.isLoggedIn}
                                    priceFormatId={this.state.priceFormatId}
                                    config={this.props.config}
                                    onAccountClicked={this.onAccountClicked}
                                    subscriptionManager={this.props.subscriptionManager}
                                    refreshBalances={this.refreshBalances.bind(this)}
                                    onShowModal={this.onShowModal}
                                    onModalClose={this.onModalClose}
                                    leftPanelToggled={this.state.leftPanelToggled}
                                    rightPanelToggled={this.state.rightPanelToggled}
                                    onLoginWidgetShow={this.onLoginWidgetShow.bind(this)}
                                    getAvailableBalance={this.getAvailableBalance.bind(this)}
                                    onLogoutRequest={this.logoutUser}
                                    togglePanel={this.togglePanel.bind(this)}
                                    userContext={this.state.userContext}
                                    isBlockedFromGames={this.state.isBlockedFromGames}
                                    onPlayGame={this.onPlayGame.bind(this)}
                                    ontogglePanel={this.togglePanel}
                                    validLocation={this.state.validLocation}
                                    punterDetails={this.state.punterDetails}
                                    modes={this.state.availableModes} />
                                } />

                                <Route path="*" render={(props) => <Wagering {...props} notfound={true} controller={this.props.controller}
                                    mode={this.state.availableModes[firstWageringIndex].toLowerCase()}
                                    history={this.props.history}
                                    setBetslip={this.setBetslip}
                                    isLoggedIn={this.state.isLoggedIn}
                                    priceFormatId={this.state.priceFormatId}
                                    config={this.props.config}
                                    onAccountClicked={this.onAccountClicked}
                                    subscriptionManager={this.props.subscriptionManager}
                                    refreshBalances={this.refreshBalances.bind(this)}
                                    onShowModal={this.onShowModal}
                                    onModalClose={this.onModalClose}
                                    leftPanelToggled={this.state.leftPanelToggled}
                                    rightPanelToggled={this.state.rightPanelToggled}
                                    onLoginWidgetShow={this.onLoginWidgetShow.bind(this)}
                                    getAvailableBalance={this.getAvailableBalance.bind(this)}
                                    onLogoutRequest={this.logoutUser}
                                    togglePanel={this.togglePanel.bind(this)}
                                    userContext={this.state.userContext}
                                    isBlockedFromGames={this.state.isBlockedFromGames}
                                    onPlayGame={this.onPlayGame.bind(this)}
                                    ontogglePanel={this.togglePanel}
                                    validLocation={this.state.validLocation}
                                    punterDetails={this.state.punterDetails}
                                    modes={this.state.availableModes} />
                                } />
                            </Switch>
                        </Suspense>

                        {configurationSettings.mode.toLowerCase() !== "gameday" &&
                            <MobileFooter
                                onLogoutRequest={this.logoutUser}
                                onAccountClicked={this.onAccountClicked}
                                isLoggedIn={this.state.isLoggedIn}
                                onLoginWidgetShow={this.onLoginWidgetShow.bind(this)}
                                userContext={this.state.userContext}
                                ontogglePanel={this.togglePanel}
                                onSearchClicked={this.onSearchClicked}
                            />
                        }

                        {!embedded && configurationSettings.mode !== "sportspools" && configurationSettings.mode.toLowerCase() !== "gameday" &&
                            <div className="row d-block" id="desktop-footer" style={{ "clear": "both" }}>
                                {GBEglobal.settings.banners &&
                                    <SeoFooter history={this.props.history} />
                                }

                                {GBEglobal.settings.nativeAppSettings && isMobile &&
                                    <NativeDownloader />
                                }
                                <Banner config={GBEglobal.settings.banners} bannerClass="footer" bannerId="footer" userContext={this.state.userContext} punterDetails={this.state.punterDetails} isBlockedFromGames={this.state.isBlockedFromGames} />
                            </div>
                        }
                        {this.state.modalConfig.show &&
                            <Modal modalConfig={this.state.modalConfig} onModalClose={this.onModalClose.bind(this)} onAccountClicked={this.onAccountClicked} />
                        }
                        <LoginWidget isLoggedIn={this.state.isLoggedIn} username={localStorage.inputUsername} onLoginRequest={this.onLoginRequest} userContext={this.state.userContext} showLoginWidget={this.state.showLoginWidget} onHideLoginWidget={this.onHideLoginWidget.bind(this)} onAccountClicked={this.onAccountClicked} hideJoinNowButton={this.state.hideJoinNowButton} />
                        <TwoFAValidationWidget onLogInVerify={this.onLogInVerify} showWidget={this.state.showTwoFAValidationWidget} onHideWidget={this.onHideTwoFAValidationWidget} />
                    </ErrorBoundary>
                }
                {this.showCookiePolicy() && <CookiePolicy></CookiePolicy>}
            </div>
        );
    }
}

export { AppLayout };